// Reads a tri-state data-requires-shipping attribute. Returns false only when explicitly "false";
// any other value (true, missing, malformed) returns undefined so callers default to "assume shippable".
function readRequiresShipping(el) {
  const val = el?.getAttribute?.('data-requires-shipping');
  if (val === 'false') return false;
  if (val === 'true') return true;
  return undefined;
}

function handleUpsellAddToCartClick(e) {
  const wrap = e.currentTarget.closest('.cartx-product-button-wrap');
  if (!wrap) return;
  const variantId = wrap.getAttribute('data-variant-id');
  if (!variantId) return;
  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrap.getAttribute('data-quantity')) || 1,
      price: parseInt(wrap.getAttribute('data-price')) || 0,
      type: wrap.getAttribute('data-product-type') || "",
      requires_shipping: readRequiresShipping(wrap),
    },
  };
  cartx(variantObject, "ADD");
}

const orgFetch = window.fetch;

window.fetch = function (...args) {
  const url = args[0];
  const isCartEndpoint = typeof url === 'string' &&
    ['/cart/add.js', '/cart/update.js', '/cart/change.js'].some(path => url.includes(path));

  if (isCartEndpoint) {
    const stack = new Error().stack || '';
    const isFromConsole = stack.includes('at <anonymous>') || stack.includes('VM');
    // Allow requests from our own cartx function and legitimate app functions
    const isFromCartx = stack.includes('cartx') || stack.includes('removeDiscount') || stack.includes('fetchCart');
    if (isFromConsole && !isFromCartx) {
      return Promise.reject('Blocked');
    }
  }
  return orgFetch.apply(this, args);
};

// Client-side time filtering for GWP offers
// Filters out offers that are outside their scheduled time window
function filterGWPByTime(gwpOffers) {
  if (!gwpOffers || !Array.isArray(gwpOffers)) return [];
  
  const now = Date.now();
  
  return gwpOffers.filter(offer => {
    // If no time fields, offer is always active
    if (!offer.offer_start_time && !offer.offer_end_time) {
      return true;
    }
    
    // Check start time
    if (offer.offer_start_time) {
      const startTime = new Date(offer.offer_start_time).getTime();
      if (now < startTime) {
        return false; // Offer hasn't started yet
      }
    }
    
    // Check end time
    if (offer.offer_end_time) {
      const endTime = new Date(offer.offer_end_time).getTime();
      if (now > endTime) {
        return false; // Offer has expired
      }
    }
    
    return true;
  });
}

// Client-side time validation for a single BOGO offer object.
// Expects offer_start_time / offer_end_time as ISO datetime strings (from bogooffers JSON).
// Returns true when the offer is currently active, false otherwise.
function isBogoOfferTimeValid(offer) {
  const now = Date.now();
  if (offer.offer_start_time) {
    const start = new Date(offer.offer_start_time).getTime();
    if (now < start) return false;
  }
  if (offer.offer_end_time) {
    const end = new Date(offer.offer_end_time).getTime();
    if (now > end) return false;
  }
  return true;
}

// Schedules a single setTimeout to trigger reload_cartx() at the next offer
// boundary (start or end) across both BOGO offers and metaobject GWPs.
// Called once on page load and re-called after every reload_cartx() completion.
let _offerTimerId = null;
function scheduleOfferTimers() {
  if (_offerTimerId !== null) {
    clearTimeout(_offerTimerId);
    _offerTimerId = null;
  }

  const now = Date.now();
  const transitions = [];

  // Collect BOGO offer time boundaries
  try {
    const bogoRaw = document.body.getAttribute("bogooffers");
    if (bogoRaw) {
      JSON.parse(bogoRaw).forEach(offer => {
        if (offer.offer_start_time) {
          const t = new Date(offer.offer_start_time).getTime();
          if (t > now) transitions.push(t);
        }
        if (offer.offer_end_time) {
          const t = new Date(offer.offer_end_time).getTime();
          if (t > now) transitions.push(t);
        }
      });
    }
  } catch (e) {}

  // Collect metaobject GWP time boundaries
  try {
    const gwpRaw = document.body.getAttribute("metaobject");
    if (gwpRaw) {
      JSON.parse(gwpRaw).forEach(offer => {
        if (offer.offer_start_time) {
          const t = new Date(offer.offer_start_time).getTime();
          if (t > now) transitions.push(t);
        }
        if (offer.offer_end_time) {
          const t = new Date(offer.offer_end_time).getTime();
          if (t > now) transitions.push(t);
        }
      });
    }
  } catch (e) {}

  if (transitions.length === 0) return;

  // Fire 500 ms after the next boundary to ensure the transition has fully occurred
  const delay = Math.min(...transitions) - now + 500;

  if (delay <= 0) return;

  // Clamp to setTimeout max (2^31 - 1 = ~24.8 days). Values above this overflow
  // and cause setTimeout to fire immediately, creating an infinite loop.
  const safeDelay = Math.min(delay, 2147483647);

  _offerTimerId = setTimeout(() => {
    _offerTimerId = null;
    // Fetch fresh cart data then reload drawer so offer state is re-evaluated
    orgFetch("/cart.js", { cache: "no-store" })
      .then(r => r.json())
      .then(cart => {
        user_cart = cart;
        if (typeof updateBubble === 'function') updateBubble(cart.item_count);
        reload_cartx();
      })
      .catch(() => reload_cartx());
  }, safeDelay);
}

// Open cart drawer if URL has ?cart=true
document.addEventListener("DOMContentLoaded", function () {
  const params = new URLSearchParams(window.location.search);
  const shouldOpenCart = params.get("cart") === "true";
  
  if (shouldOpenCart) {
    // Use setTimeout to ensure cart data is loaded first
    setTimeout(function() {
      const cartDrawer = document.querySelector("cart-drawer");
      const overlay = document.getElementById("cartx-drawer-overlay");

      if (cartDrawer && overlay) {
        cartDrawer.classList.add("drawer-open");
        overlay.classList.add("open-overlay");
      }
      document.body.classList.add("cartx-open");
      
      // Reload cart drawer to show fresh content
      if (typeof reload_cartx === 'function') {
        reload_cartx();
      }
    }, 100);
    
    // Remove ?cart=true from URL without reload
    if (window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.delete("cart");
      window.history.replaceState({}, document.title, url.pathname + url.search);
    }
  }
  
  // Delegated event listener for coupon input - enables/disables apply button
  document.addEventListener("input", function (e) {
    if (!e.target.classList.contains("prv-coupon-input")) return;
    const container = e.target.closest(".prv-coupon-input-container");
    if (!container) return;
    const btn = container.querySelector(".prv-submit-button");
    if (!btn) return;
    const hasValue = e.target.value.trim().length > 0;
    btn.classList.toggle("disabled", !hasValue);
    btn.disabled = !hasValue;
  });
  
  // Use event delegation for checkout button clicks (works for dynamically loaded buttons)
  document.addEventListener("click", function(e) {
    const target = e.target.closest('.cartx-checkout-button, [href*="/checkout"], [href*="/checkouts/"]');
    if (target) {
      sessionStorage.setItem("cartx_went_to_checkout", "true");
    }
  });
});

// Refresh cart data when navigating back from checkout (handles bfcache and normal back navigation)
// Note: We use AJAX refresh instead of page reload to preserve Shopify checkout session and applied discounts
window.addEventListener("pageshow", function (event) {
  const returningFromCheckout = sessionStorage.getItem("cartx_went_to_checkout") === "true";
  const referrer = document.referrer || '';
  const fromCheckoutReferrer = referrer.includes('/checkout') || referrer.includes('/checkouts/');



  // Only refresh if we explicitly went to checkout (via our button click)
  // Don't use fromCheckoutReferrer alone as it can trigger on back navigation after applying checkout discounts
  if (returningFromCheckout) {
    sessionStorage.removeItem("cartx_went_to_checkout");

    // Fetch fresh cart data and reload drawer (preserves checkout session)
    orgFetch("/cart.js", { cache: "no-store" })
      .then(response => response.json())
      .then(cart => {

        user_cart = cart;

        // Sync discount attributes with actual applied discounts
        return syncDiscountAttributes(cart).then(() => {
          reload_cartx(); // checkDiscountCode is called inside reload_cartx.finally()
          if (typeof updateBubble === 'function') {
            updateBubble(cart.item_count);
          }
        });
      })
      .catch(error => console.error("Error refreshing cart on checkout return:", error));
    return;
  }
  
  // For bfcache restoration (not from checkout), also refresh cart data
  if (event.persisted) {

    orgFetch("/cart.js", { cache: "no-store" })
      .then(response => response.json())
      .then(cart => {
        user_cart = cart;
        // Pass skipGiftSync=true to prevent auto-re-adding removed gifts on back navigation
        reload_cartx(false, null, null, true);
        if (typeof updateBubble === 'function') {
          updateBubble(cart.item_count);
        }
      })
      .catch(error => console.error("Error refreshing cart on bfcache restore:", error));
  }
});

// Also handle visibility change (for mobile browsers and tab switching)
document.addEventListener("visibilitychange", function() {
  if (document.visibilityState === "visible") {
    const returningFromCheckout = sessionStorage.getItem("cartx_went_to_checkout") === "true";
    if (returningFromCheckout) {
      sessionStorage.removeItem("cartx_went_to_checkout");

      // Fetch fresh cart data (preserves checkout session)
      orgFetch("/cart.js", { cache: "no-store" })
        .then(response => response.json())
        .then(cart => {
          user_cart = cart;
          return syncDiscountAttributes(cart).then(() => {
            reload_cartx(); // checkDiscountCode is called inside reload_cartx.finally()
            if (typeof updateBubble === 'function') {
              updateBubble(cart.item_count);
            }
          });
        })
        .catch(() => {});
    }
  }
});

let freeGiftPrice = 100;
let priceArray = [0, 1];
let currentDiscountCodes = [];

// Codes confirmed as automatic — persisted to sessionStorage so page reloads and
// temporary Shopify conflict states (where allocations disappear) don't lose the classification.
const knownAutomaticCodes = new Set(
  (() => { try { return JSON.parse(sessionStorage.getItem('cartx_auto_codes') || '[]'); } catch(e) { return []; } })()
);
function _persistAutoCode(code) {
  knownAutomaticCodes.add(code);
  try { sessionStorage.setItem('cartx_auto_codes', JSON.stringify([...knownAutomaticCodes])); } catch(e) {}
}

var user_cart = null;

// ===== DEBUG LOGGING UTILITY (DISABLED) =====
// cartxLog intentionally no-ops to avoid emitting logs from this script
function cartxLog() { /* no-op */ }
// ===== END DEBUG LOGGING UTILITY =====
let isProcessing = false;
let showConfetti = false;
let isSyncingGifts = false;
let giftSyncPending = false;
let lastAddedProductHandle = null;
let pendingMessage = null;
let reloadDepth = 0;


// ===== Gift Reordering Functions =====
// These are defined here (not in the Liquid snippet) so they persist across AJAX reloads
// Helper function to get progress percentage from a gift item
function getGiftProgress(item) {
  const progressFill = item.querySelector('.cartx-progress-fill');
  if (!progressFill) return 0;
  const widthStyle = progressFill.style.width;
  return parseFloat(widthStyle) || 0;
}

// Function to reorder gift items - unlocked gifts come first, then by progress
function reorderGiftItems() {
  const container = document.querySelector('.cartx-gift-unlock-container');
  if (!container) {
    return;
  }
  
  const giftItems = Array.from(container.querySelectorAll('.cartx-gift-item:not([style*="display: none"])'));
  if (giftItems.length <= 1) {
    return;
  }
  
  // Separate unlocked and locked items
  const unlockedItems = giftItems.filter(item => item.classList.contains('cartx-unlocked'));
  const lockedItems = giftItems.filter(item => item.classList.contains('cartx-locked'));
  
  // Sort unlocked items by progress (higher first) - for consistency
  unlockedItems.sort((a, b) => getGiftProgress(b) - getGiftProgress(a));
  
  // Sort locked items by progress percentage (higher progress = earlier in list)
  lockedItems.sort((a, b) => getGiftProgress(b) - getGiftProgress(a));
  
  // Check if reordering is needed
  let needsReorder = false;
  const sortedItems = [...unlockedItems, ...lockedItems];
  
  for (let i = 0; i < giftItems.length; i++) {
    if (giftItems[i] !== sortedItems[i]) {
      needsReorder = true;
      break;
    }
  }
  
  if (!needsReorder) {
    return;
  }
  
  const scrollLeft = container.scrollLeft;
  
  // Add reordering class for initial state (hidden/offset)
  sortedItems.forEach(item => {
    item.classList.add('cartx-reordering');
  });
  
  // Reorder DOM elements
  sortedItems.forEach(item => {
    container.appendChild(item);
  });
  
  // Trigger reflow to ensure the reordering class is applied
  container.offsetHeight;
  
  // Restore scroll position
  container.scrollLeft = scrollLeft;
  
  // Add animation class and remove reordering class to animate in
  requestAnimationFrame(() => {
    sortedItems.forEach((item, index) => {
      setTimeout(() => {
        item.classList.add('cartx-reorder-animate');
        item.classList.remove('cartx-reordering');
      }, index * 50); // Staggered animation
    });
    
    // Clean up animation classes after transition completes
    setTimeout(() => {
      sortedItems.forEach(item => {
        item.classList.remove('cartx-reorder-animate');
      });
    }, 500 + (sortedItems.length * 50));
  });
}

// Expose globally for manual triggering
window.reorderGiftItems = reorderGiftItems;

// Schedule offer boundary timers on page load so start/expiry events trigger
// a reload_cartx() automatically without requiring user cart interaction.
scheduleOfferTimers();

// Always fetch cart on page load to ensure we have fresh data.
// After the initial fetch, run the login-coupon detection once in isolation.
fetchCart().then(function(cart) {
  if (!cart) return;
  const customerEl = document.querySelector('.wc_customer_id');
  const currentCustomerId = customerEl ? (customerEl.getAttribute('data-customer-id') || '') : '';
  const storedCustomerId = sessionStorage.getItem('cartx_customer_id');
  sessionStorage.setItem('cartx_customer_id', currentCustomerId);

  // storedId === null → first ever visit, just initialise
  // storedId === ''   → was a guest; if now logged in → just logged in
  if (storedCustomerId === '' && currentCustomerId !== '') {
    (async () => {
      try { await orgFetch('/checkout', { credentials: 'include' }); } catch (_) {}
      try {
        const freshCart = await orgFetch('/cart.js', { cache: 'no-store' }).then(r => r.json());
        user_cart = freshCart;
        await syncDiscountAttributes(freshCart);
        if (typeof checkDiscountCode === 'function') checkDiscountCode(freshCart);
        if (typeof updateBubble === 'function') updateBubble(freshCart.item_count);
        // After login, auto-discounts may reduce cart total below GWP thresholds.
        // Reload the drawer to trigger computeGwpThresholdRemovals() and remove
        // any GWP freebies that no longer qualify.
        reload_cartx();
      } catch (err) { console.error('[CartX Login] refresh error:', err); }
    })();
  }
});

function fetchCart(reloadDrawer = false) {


  return orgFetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {

      user_cart = cart;


      // If cart has items and we need to reload drawer
      if (reloadDrawer && cart.item_count > 0) {

        reload_cartx();
      } else {
        // Normal page load - just bind events without modifying cart state.
        // The server already has the correct cart state; calling cartx() here
        // can incorrectly remove GWP/freebie items due to rule mismatches.
        bindingEvent();

        // Remove GWP gifts from expired offers or when cart is below threshold
        if (cart.item_count > 0) {
          const gwpRemovals = computeGwpThresholdRemovals();
          if (Object.keys(gwpRemovals).length > 0) {
            orgFetch("/cart/update.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ updates: gwpRemovals })
            })
            .then(r => r.ok ? r.json() : null)
            .then(freshCart => {
              if (freshCart) {
                user_cart = freshCart;
                if (typeof updateBubble === 'function') updateBubble(freshCart.item_count);
                reload_cartx();
              }
            })
            .catch(() => {});
          }
        }
      }

      // Update inventory states after cart is loaded
      if (typeof updateInventoryStates === 'function') {
        updateInventoryStates();
      }

      // Update cart bubble count
      if (typeof updateBubble === 'function') {
        updateBubble(cart.item_count);
      }

      // Render applied discount codes on page load
      if (typeof checkDiscountCode === 'function') {
        checkDiscountCode(cart);
      }

      return cart;
    })
    .catch(() => {});
}

var QTY_COOLDOWN_MS = 1000;

function bindingEvent() {
  document
    .querySelectorAll(".cartx-drawer-product-quantity-button")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const eventName = button.getAttribute("name");

        if (eventName !== "plus" && eventName !== "minus") return;

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        // --- Cooldown: disable both +/- buttons until cart update completes ---
        const qtyButtons = li.querySelectorAll('.cartx-drawer-product-quantity-button');
        qtyButtons.forEach(btn => {
          btn.disabled = true;
          btn.style.opacity = '0.4';
        });
        function reenableButtons() {
          if (isProcessing) {
            setTimeout(reenableButtons, 200);
            return;
          }
          qtyButtons.forEach(btn => {
            btn.disabled = false;
            btn.style.opacity = '';
          });
        }
        setTimeout(reenableButtons, QTY_COOLDOWN_MS);

        const unitPrice = parseInt(li.getAttribute("data-price")) || 0;

        const variantObject = {
          [variantId]: {
            quantity: parseInt(li.getAttribute("data-quantity")) || 0,
            price: unitPrice,
            type: li.getAttribute("data-product-type") || "",
            requires_shipping: readRequiresShipping(li),
          },
        };

        switch (eventName) {
          case "plus":
            cartx(variantObject, "ADD");
            break;
          case "minus":
            cartx(variantObject, "REMOVE");
            break;
        }
      });
    });

  // Simple BOGO Bundle Multi-Add Event Listener
  document
    .querySelectorAll('.cartx-bogo-offer-add-to-cart')
    .forEach(button => {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        // Find the parent container and collect all variants
        const upsellContainer = this.closest('.cartx-bogo-offer-wrap')?.querySelector('.cartx-upsell-product-list')

        const variantObject = {};


        if (upsellContainer) {
          const productItems = upsellContainer.querySelectorAll('.cartx-upsell-product-item');

          productItems.forEach(item => {
            const buttonWrap = item.querySelector('.cartx-product-button-wrap');

            if (buttonWrap) {
              const variantId = buttonWrap.getAttribute('data-variant-id');
              const price = buttonWrap.getAttribute('data-price');
              const productType = buttonWrap.getAttribute('data-product-type');
              const quantity = buttonWrap.getAttribute('data-quantity');

              if (variantId && price) {
                variantObject[variantId] = {
                  quantity: parseInt(quantity) || 1,
                  price: parseInt(price) || 0,
                  type: productType || "",
                };
              }
            }
          });
        }

        // Call cartx function with MULTI_ADD event
        if (Object.keys(variantObject).length > 0) {
          cartx(variantObject, "MULTI_ADD");
        }
      });
    });

  const ribbons = document.querySelectorAll(".cartx-announcement-ribbon");

  ribbons.forEach(ribbon => {
    const leftBtn = ribbon.querySelector(".scroll-btn.left");
    const rightBtn = ribbon.querySelector(".scroll-btn.right");

    const scrollableItems = ribbon.querySelectorAll(".cartx-announcement-ribbon-text");

    leftBtn.addEventListener("click", () => {
      ribbon.scrollBy({ left: -200, behavior: "smooth" });
    });

    rightBtn.addEventListener("click", () => {
      ribbon.scrollBy({ left: 200, behavior: "smooth" });
    });
  });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "CLAIM_ADD");
      });
    });

  document
    .querySelectorAll(".cartx-free-claim-buttton.cartx-claim-remove-from-cart")
    .forEach((button) => {
      button.addEventListener("click", (event) => {
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [variantId]: {
            quantity: 1,
            claimed_gift: "true",
          },
        };

        cartx(variantObject, "CLAIM_REMOVE");
      });
    });

  document.querySelectorAll(".code-copy-btn").forEach(function (button) {
    button.addEventListener("click", function () {
      const valueToCopy = this.getAttribute("data-code");

      if (valueToCopy) {
        // Copy to clipboard
        const tempInput = document.createElement("input");
        document.body.appendChild(tempInput);
        tempInput.value = valueToCopy;
        tempInput.select();
        document.execCommand("copy");
        document.body.removeChild(tempInput);

        // Show popup message with animation
        const popup = document.createElement("div");
        popup.className = "copy-popup";
        popup.textContent = "Copied successfully!";
        document.body.appendChild(popup);

        popup.style.position = "fixed";
        popup.style.bottom = "-50px";
        popup.style.left = "50%";
        popup.style.transform = "translateX(-50%)";
        popup.style.opacity = 0;
        popup.style.transition = "all 0.3s ease";

        // Force reflow to apply transition
        void popup.offsetHeight;

        // Animate in
        popup.style.bottom = "70px";
        popup.style.opacity = 1;
        setTimeout(function () {
          popup.style.transition = "all 0.3s ease";
          popup.style.bottom = "0px";
          popup.style.opacity = "0";

          setTimeout(function () {
            popup.remove();
          }, 300);
        }, 1000);
      }
    });
  });

  document.querySelectorAll(".cartx-empty-upsell").forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault();
      const variantId = button.getAttribute("data-variant-id");
      if (!variantId) return;

      const variantObject = {
        [variantId]: {
          quantity: parseInt(button.getAttribute("data-quantity")) || 0,
          price: parseInt(button.getAttribute("data-price")) || 0,
          type: button.getAttribute("data-product-type") || "",
          requires_shipping: readRequiresShipping(button),
        },
      };

      cartx(variantObject, "ADD");
    });
  });

  document.querySelectorAll(".prv-submit-button").forEach((button) => {
    button.addEventListener("click", function () {
      const input = this.closest(".prv-coupon-input-container").querySelector(
        ".prv-coupon-input"
      );
      applyCode(input);
    });
  });

  document.querySelectorAll(".prv-coupon-input").forEach((input) => {
    // Enable/disable apply button based on input value
    input.addEventListener("input", function () {
      const container = this.closest(".prv-coupon-input-container");
      if (!container) return;
      const btn = container.querySelector(".prv-submit-button");
      if (!btn) return;
      const hasValue = this.value.trim().length > 0;
      btn.classList.toggle("disabled", !hasValue);
      btn.disabled = !hasValue;
    });
    
    input.addEventListener("keypress", function (e) {
      if (e.key === "Enter") {
        applyCode(input);
      }
    });
  });

  const removeBtnEl = document.getElementById("cartx-remove-btn");
  if (removeBtnEl !== null) {
    const newRemoveBtn = removeBtnEl.cloneNode(true);
    removeBtnEl.parentNode.replaceChild(newRemoveBtn, removeBtnEl);
    newRemoveBtn.addEventListener("click", function () {
      const code = this.getAttribute("data-discount-code");
      removeDiscount(user_cart?.token, code);
    });
  }

  const slider = document.getElementById("cartx-claim-product-list");
  const progress = document.getElementById("scrollProgress");

  if (slider && progress) {
    slider.addEventListener("scroll", () => {
      const scrollLeft = slider.scrollLeft;
      const scrollWidth = slider.scrollWidth - slider.clientWidth;
      const scrolledPercent = (scrollLeft / scrollWidth) * 100;
      progress.style.width = `${scrolledPercent}%`;
    });
  }

  document
    .querySelectorAll(".cartx-variant-cart")
    .forEach(function (selector) {

      selector.addEventListener("change", function (event) {
        const selectedOption = event.target.selectedOptions[0];
        const selectedVariantId = selectedOption.value;
        const variantPrice = selectedOption.getAttribute("data-price");
        const quantity = selectedOption.getAttribute("data-quantity");
        const type = selectedOption.getAttribute("data-product-type");
        const finalPrice = selectedOption.getAttribute("data-final-price");

        const li = event.target.closest("li");
        if (!li) return;

        const variantId = li.getAttribute("data-variant-id");
        if (!variantId) return;

        const variantObject = {
          [selectedVariantId]: {
            quantity: Number(quantity),
            replace_variant: variantId,
            price: variantPrice,
            type: type,
            final_price: finalPrice,
            requires_shipping: readRequiresShipping(selectedOption),
          },
        };

        cartx(variantObject, "ADD");
      });
    });

  document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
    // Remove the previous event listener, if any
    selector.removeEventListener("change", handleVariantChange);

    // Add the new event listener
    selector.addEventListener("change", handleVariantChange);
  });

  const viewAllBtn = document.querySelector(".prv-view-all");
  const offerPanel = document.querySelector(".cartx-all-offers");

  // Replace drawer with offers panel (show/hide logic)
  if (viewAllBtn && offerPanel) {
    viewAllBtn.addEventListener("click", function () {
      if (!viewAllBtn.classList.contains("disabled")) {
        offerPanel.classList.add("is--visible");
      }
    });
    
    // Attach close events to both back arrow and close button
    const closeBtns = offerPanel.querySelectorAll('.cartx-all-offers-close, .cartx-all-offers-close-btn');
    closeBtns.forEach(function(closeBtn) {
      closeBtn.addEventListener('click', function () {
        offerPanel.classList.remove("is--visible");
      });
    });
  }

  const signinBtn = document.getElementById("cartx-signin-btn");
  if (signinBtn) {
    signinBtn.addEventListener("click", function (event) {
      event.preventDefault();
      // Flag persists across all intermediate redirects until we find a logged-in state
      sessionStorage.setItem('cartx_needs_coupon_refresh', 'true');
      const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = "/account/login?return_url=" + returnUrl;
    });
  }

  const applyButtons = document.querySelectorAll(".cartx-apply-button-wrapper");
  if (applyButtons.length > 0) {
    applyButtons.forEach(function (button) {
      // Remove existing listener to prevent duplicates
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      newButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const couponCode = this.getAttribute("data-code");
        if (couponCode) {
          applyDiscount(user_cart?.token, couponCode);
        }
      });
    });
  }

  const removeButtons = document.querySelectorAll(
    ".cartx-remove-button-wrapper"
  );
  if (removeButtons.length > 0) {
    removeButtons.forEach(function (button) {
      // Remove existing listener to prevent duplicates
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
      newButton.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        const couponCode = this.getAttribute("data-code");
        if (couponCode) {
          removeDiscount(user_cart?.token, couponCode);
        }
      });
    });
  }

  document.querySelectorAll('.shipping-info-toggle').forEach(function (toggleBtn) {
    toggleBtn.addEventListener('click', function () {
      const infoBox = document.querySelector('.shipping-info-content');
      infoBox.classList.toggle('open');
      toggleBtn.setAttribute('aria-expanded', infoBox.classList.contains('open'));
    });
  });

  const cartxNoteTextarea = document.getElementById("CartxSpecialInstructions");
  const cartxNoteInputGroup = cartxNoteTextarea?.closest(".input-group");

  function toggleCheckIcon() {
    if (cartxNoteTextarea?.value.trim().length > 0) {
      cartxNoteInputGroup.classList.add("filled");
    } else {
      cartxNoteInputGroup.classList.remove("filled");
    }
  }

  if (cartxNoteTextarea) {
    toggleCheckIcon();
  }

  cartxNoteTextarea?.addEventListener('change', function () {
    toggleCheckIcon();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        note: this.value
      })
    });
  });

  // for Footwear Fit Protect ----- start
  const protectorVariantSelect = document.getElementById('protectorVariantSelect');

  protectorVariantSelect?.addEventListener('change', function () {
    const selectedValue = this.value;
    const selectedOption = this.options[this.selectedIndex];
    const selectedPrice = selectedOption.dataset.price;
    if (selectedValue != 0) {
      protectorVariantSelect.setAttribute("data-variant-id", selectedValue);
      protectorVariantSelect.setAttribute("data-price", selectedPrice);
      protectorAddToCartClick();
    } else {
      protectorRemoveFromCartClick();
    }
  });

  function protectorAddToCartClick(variantID, event) {

    const wrapper = document.querySelector("#protectorVariantSelect");
    const variantId = wrapper.getAttribute("data-variant-id");
    if (!variantId) return;

    const variantObject = {
      [variantId]: {
        quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
        price: parseInt(wrapper.getAttribute("data-price")) || 0,
        type: wrapper.getAttribute("data-product-type") || "",
      },
    };

    cartx(variantObject, "ADD");
  }

  function protectorRemoveFromCartClick(event) {
    const wrapper = document.querySelector("#protectorVariantSelect");
    const variantId = wrapper.getAttribute("data-variant-id");
    if (!variantId) return;

    const variantObject = {
      [variantId]: {
        quantity: 0,
        price: parseInt(wrapper.getAttribute("data-price")) || 0,
        type: wrapper.getAttribute("data-product-type") || "",
      },
    };

    cartx(variantObject, "REMOVE PROTECTOR");
  }
  // for Footwear Fit Protect ----- end

  // for Apparel multy Protect ----- start
  const apparelProtectorVariantSelect = document.getElementById('apparelProtectorVariantSelect');

  apparelProtectorVariantSelect?.addEventListener('change', function () {
    const selectedValue = this.value;
    const selectedOption = this.options[this.selectedIndex];
    const selectedPrice = selectedOption.dataset.price;
    if (selectedValue != 0) {
      apparelProtectorVariantSelect.setAttribute("data-variant-id", selectedValue);
      apparelProtectorVariantSelect.setAttribute("data-price", selectedPrice);
      apparelProtectorAddToCartClick();
    } else {
      apparelProtectorRemoveFromCartClick();
    }
  });

  function apparelProtectorAddToCartClick(variantID, event) {
    const wrapper = document.getElementById('apparelProtectorVariantSelect');
    const variantId = wrapper.getAttribute("data-variant-id");
    if (!variantId) return;

    const variantObject = {
      [variantId]: {
        quantity: parseInt(wrapper.getAttribute("data-quantity")) || 1,
        price: parseInt(wrapper.getAttribute("data-price")) || 0,
        type: wrapper.getAttribute("data-product-type") || "",
      },
    };

    cartx(variantObject, "ADD");
  }

  function apparelProtectorRemoveFromCartClick(event) {
    const wrapper = document.getElementById('apparelProtectorVariantSelect');
    const variantId = wrapper.getAttribute("data-variant-id");
    if (!variantId) return;

    const variantObject = {
      [variantId]: {
        quantity: 0,
        price: parseInt(wrapper.getAttribute("data-price")) || 0,
        type: wrapper.getAttribute("data-product-type") || "",
      },
    };

    cartx(variantObject, "REMOVE PROTECTOR");
  }

  // for Apparel multy Protect ----- end

  const checkoutBtn = document.querySelector(".cartx-checkout-button");
  const policyCheckbox = document.querySelector("#agreePolicy");
  const policyText = document.querySelector(".policy-text");
  const policyLinks = policyText?.querySelectorAll("a");
  const policyCheckboxBox = document.querySelector(".custom-checkbox");
  const drawerInner = document.querySelector(".cartx-drawer-body-wrap");

  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      e.preventDefault();
      // Set flag BEFORE redirect so we can detect return from checkout
      sessionStorage.setItem("cartx_went_to_checkout", "true");
      // Simply redirect to checkout
      window.location.href = "/checkout";
    });
  }

  initPincodeInput();

  loadedEvents();
}

function handleVariantChange(event) {

  const selectedOption = event.target.selectedOptions[0];
  const selectedVariantId = selectedOption.value;
  const variantPrice = selectedOption.getAttribute("data-price");
  const type = selectedOption.getAttribute("data-product-type");
  const image = selectedOption.getAttribute("data-image");

  const li = event.target.closest(".cartx-upsell-product-item").querySelector('.cartx-product-button-wrap');
  if (!li) return;

  const formattedPrice = `₹ ${(parseInt(variantPrice) / 100).toFixed(2)}`;

  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-img').src = image;
  li.closest('.cartx-upsell-product-item').querySelector('.cartx-upsell-item-price .current-price').innerHTML = formattedPrice;
  li.setAttribute("data-variant-id", selectedVariantId);
  li.setAttribute("data-price", variantPrice);
  li.setAttribute("data-product-type", type);
}


function isValidIndianPincodeCart(pincode) {
  var pincodeInput = document.getElementById("pincode_input_cart");
  var expectedCart = document.querySelector(".cartx-drawer .expected_cart");
  pincodeInput.style.color = "#f00";
  expectedCart.textContent = "Enter a valid pincode";
  expectedCart.style.color = "#f00";
  // pincodeInput.style.borderColor = "#f00";
  document.querySelector(".cartx-verified-cart-svg").classList.remove('show-svg');
  // document.getElementById("verified_cart").style.display = "none";
  var regex = /^[1-9][0-9]{5}$/;
  return regex.test(pincode);
}

function getFormattedDate(date) {
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString("en-IN", options);
}

function handlePincodeInputChangeCart() {
  var pincode = document.getElementById("pincode_input_cart").value;
  if (isValidIndianPincodeCart(pincode)) {
    localStorage.setItem("validPin", pincode);
    document.getElementById("pincode_input_cart").style.color = "green";
    // document.getElementById("pincode_input_cart").style.borderColor = "black";
    // document.getElementById("verified_cart").style.display = "block";

    var url = "https://neworder.plumgoodness.com/get-estimate-date";
    var data = JSON.stringify({ drop_pincode: pincode });

    var xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var result = JSON.parse(xhr.responseText);
        var expectedCart = document.querySelector(".cartx-drawer .expected_cart");

        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + parseInt(result.expects_max_date));
        // Adding 12 hours to the current time
        currentDate.setHours(currentDate.getHours());
        currentDate.setDate(currentDate.getDate() + 1);

        const formattedDate = getFormattedDate(currentDate);
        expectedCart.innerHTML = `Estimated Delivery Date <br> ${formattedDate}`;
        expectedCart.style.color = "green";
        document.querySelector(".cartx-verified-cart-svg").classList.add('show-svg');
      }
    };
    xhr.send(data);
  }
}

function getFormattedDate(date) {
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' });
  const weekday = date.toLocaleString('default', { weekday: 'long' });

  return `${day}${this.getDaySuffix(day)} ${month}, ${weekday}`;
}

function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return 'th';
  }
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
}

function initPincodeInput() {
  const inputField = document.getElementById("pincode_input_cart");
  if (!inputField) return;

  const storedPin = localStorage.getItem("validPin");
  if (storedPin) {
    inputField.value = storedPin;
    handlePincodeInputChangeCart(); // run immediately
  }

  inputField.addEventListener("keyup", handlePincodeInputChangeCart);
}

function startLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.add("loading");
  }
}

function stopLoader() {
  const cartLoader = document.querySelector(".cartx-atc-cart-loading");
  if (cartLoader) {
    cartLoader.classList.remove("loading");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Note: Checkout return is now handled by pageshow event with full page refresh
  // This handler now just handles normal page initialization

  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1 && node.classList.contains("cartx-product-button-wrap")) {

          loadedEvents();
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });


  loadedEvents();
});

function handleAddToCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  let variantId = wrapper.getAttribute("data-variant-id");
  
  // Fallback: try to get variant ID from form if not in wrapper
  if (!variantId) {
    const variantIdInput = document.querySelector("[product-single-form-variant-id]");
    variantId = variantIdInput?.value;
  }
  
  if (!variantId) return;

  // Check if button is sold out, at max stock, or disabled
  if (button.classList.contains('cartx-sold-out') || button.classList.contains('cartx-max-stock') || button.disabled) {
    // Show message for sold out products
    if (button.classList.contains('cartx-sold-out')) {
      showMessage('This product is currently sold out', true);
    } else if (button.classList.contains('cartx-max-stock')) {
      showMessage('Maximum quantity reached in cart', true);
    }
    return;
  }

  // Check inventory limit before adding
  const maxInventory = parseInt(wrapper.getAttribute("data-inventory")) || 9999;
  const inCart = parseInt(wrapper.getAttribute("data-in-cart")) || 0;
  
  // Get current quantity in cart for this variant
  let currentQtyInCart = inCart;
  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == variantId);
    if (cartItem) {
      currentQtyInCart = cartItem.quantity;
    }
  }

  // Try to get quantity from form's quantity input (for PDP), otherwise use data-quantity
  let quantity = parseInt(wrapper.getAttribute("data-quantity")) || 1;
  const form = wrapper.closest("form");
  if (form) {
    const quantityInput = form.querySelector("[product-single-form-quantity-value]");
    if (quantityInput) {
      quantity = parseInt(quantityInput.value) || 1;
    }
  }

  // Check if adding this quantity would exceed inventory
  if (currentQtyInCart + quantity > maxInventory) {
    const remainingQty = maxInventory - currentQtyInCart;
    if (remainingQty <= 0) {
      showExceedingMessage(`Maximum quantity (${maxInventory}) already in cart`);
      return;
    }
    // Reduce quantity to what's available
    quantity = remainingQty;
  }

  // Close quick view overlay smoothly if the ATC button is inside one.
  // Fade out first, then trigger the real close after the cart drawer starts opening.
  const quickViewOverlay = wrapper.closest('#custom-overlay, #search-overlay');
  if (quickViewOverlay) {
    quickViewOverlay.style.transition = 'opacity 0.3s ease';
    quickViewOverlay.style.opacity = '0';
    setTimeout(() => {
      quickViewOverlay.style.transition = '';
      quickViewOverlay.style.opacity = '';
      quickViewOverlay.dispatchEvent(new MouseEvent('click', { bubbles: false }));
    }, 350);
  }

  wrapper.classList.add("cartx-button-loadding");
  // Hide button text and show loader SVG inside the button
  const atcButton = wrapper.querySelector('.cartx-add-to-cart');
  const loader = atcButton?.querySelector('.cartx-atc-loading');
  if (atcButton && loader) {
    atcButton.querySelector('span')?.classList.add('hide');
    loader.style.display = 'flex';
  }

  const variantObject = {
    [variantId]: {
      quantity: quantity,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
      requires_shipping: readRequiresShipping(wrapper),
    },
  };

  cartx(variantObject, "ADD");
}

function handleRemoveFromCartClick(event) {
  const button = event.currentTarget;

  const wrapper = button.closest(".cartx-product-button-wrap");
  const variantId = wrapper.getAttribute("data-variant-id");
  if (!variantId) return;

  wrapper.classList.add("cartx-button-loadding");

  const variantObject = {
    [variantId]: {
      quantity: parseInt(wrapper.getAttribute("data-quantity")) || 0,
      price: parseInt(wrapper.getAttribute("data-price")) || 0,
      type: wrapper.getAttribute("data-product-type") || "",
      requires_shipping: readRequiresShipping(wrapper),
    },
  };

  cartx(variantObject, "REMOVE");
}

// Flag to ensure document-level click listener is only added once
let documentClickListenerAdded = false;

function loadedEvents() {

  document
    .querySelectorAll(".cartx-upsell-product-item .cartx-add-to-cart")
    .forEach((button) => {
      button.addEventListener("click", (e) => {
        e.stopPropagation();
        // Hide the upsell product item when added to cart
        const upsellItem = button.closest('.cartx-upsell-product-item');
        if (upsellItem) {
          upsellItem.style.display = 'none';
        }
        handleUpsellAddToCartClick({
          currentTarget: button,
          target: e.target,
          preventDefault: e.preventDefault ? e.preventDefault.bind(e) : () => { },
        });
        return;
      });
    });

  if (!documentClickListenerAdded) {
    document.addEventListener("click", function (e) {
      const button = e.target.closest(".cartx-add-to-cart:not(.plus):not(.cartx-sold-out):not(.cartx-max-stock)");
      if (button) {
        // button.removeEventListener("click", handleAddToCartClick);
        // button.addEventListener("click", handleAddToCartClick);
        handleAddToCartClick({
          currentTarget: button
        });
      }
    });
    documentClickListenerAdded = true;
  }

  document.querySelectorAll(".cartx-add-to-cart.plus").forEach((button) => {

    button.removeEventListener("click", handleAddToCartClick);
    button.addEventListener("click", handleAddToCartClick);
  });

  document
    .querySelectorAll(".cartx-remove-from-cart.minus")
    .forEach((button) => {

      button.removeEventListener("click", handleRemoveFromCartClick);
      button.addEventListener("click", handleRemoveFromCartClick);
    });

  document
    .querySelectorAll(".cartx-icon")
    .forEach((button) => {

      button.removeEventListener("click", openDrawer);
      button.addEventListener("click", openDrawer);
    });

  document.querySelectorAll(".cartx-variant-upsell").forEach(function (selector) {
    // Remove the previous event listener, if any
    selector.removeEventListener("change", handleVariantChange);

    // Add the new event listener
    selector.addEventListener("change", handleVariantChange);
  });

  document.querySelectorAll('.cartx-variant-switcher').forEach(function (selector) {
    selector.removeEventListener("click", handleVariantChangeQuantity);
    selector.addEventListener("click", handleVariantChangeQuantity);
  })

  // Note: Removed updateInventoryStates() call from here to prevent
  // overriding server-side rendered sold out states on page load

}

function handleVariantChangeQuantity(event) {


  const variantId = event.target.getAttribute("data-variant-id");
  const productId = event.target.getAttribute("data-product-id");
  const price = event.target.getAttribute("data-variant-price");


  document.querySelectorAll('.cartx-product-button-wrap[data-product-id="' + productId + '"]').forEach(function (selector) {
    selector.setAttribute("data-variant-id", variantId);
    selector.setAttribute("data-price", price);

  });

  let quantity = 0;

  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == variantId);
    quantity = cartItem ? cartItem.quantity : 0;
  }

  updateQuantity({ [variantId]: { quantity } }, 'CHANGE');
}

// Named handler function for cart drawer click events (so we can remove it later)
function cartDrawerClickHandler(event) {
  const cartDrawer = document.querySelector("cart-drawer");

  if (cartDrawer && cartDrawer.classList.contains("drawer-open")) {
    // Check if clicked on overlay or cart-drawer but not on inner content
    if (event.target.id === "cartx-drawer-overlay" ||
      (event.target.tagName === "CART-DRAWER" && event.target === cartDrawer)) {
      closeDrawer();
    }
  }
}

function openDrawer(event) {
  event.preventDefault();
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");
  if (cartDrawer && overlay) {
    cartDrawer.classList.add("drawer-open");
    overlay.classList.add("open-overlay");
  }
  document.body.classList.add("cartx-open");

  // Sync cart count and drawer content immediately on open to prevent stale bfcache state
  orgFetch("/cart.js", { cache: "no-store" })
    .then(r => r.json())
    .then(cart => {
      user_cart = cart;
      if (typeof updateBubble === 'function') updateBubble(cart.item_count);
      if (typeof reload_cartx === 'function') reload_cartx();
    })
    .catch(() => {
      if (typeof reload_cartx === 'function') reload_cartx();
    });

  // Add click handler using addEventListener (remove first to prevent duplicates)
  setTimeout(() => {
    window.removeEventListener('click', cartDrawerClickHandler);
    window.addEventListener('click', cartDrawerClickHandler);
  }, 100);
}

function closeDrawer() {
  const cartDrawer = document.querySelector("cart-drawer");
  const overlay = document.querySelector(".cartx-drawer-overlay");

  if (cartDrawer && overlay) {
    cartDrawer.classList.remove("drawer-open");
    overlay.classList.remove("open-overlay");
  }

  // Reset offer panel state so cart opens with main view next time
  const offerPanel = document.querySelector(".cartx-all-offers");
  if (offerPanel) {
    offerPanel.classList.remove("is--visible");
  }

  document.body.classList.remove("cartx-open");
  window.removeEventListener('click', cartDrawerClickHandler);
}

function cartx(variantObject = {}, event, shouldOpenDrawer = true, skipLoader = false) {


  if (isProcessing) {

    updateQuantity(variantObject, null);
    return;
  }

  var footwearProtectId = document.querySelector("cart-drawer #protectorVariantSelect")?.getAttribute("data-variant-id");
  var apparelProtectId = document.querySelector("cart-drawer #apparelProtectorVariantSelect")?.getAttribute("data-variant-id");
  let totalFootwearQty = 0;
  let totalApparelPrice = 0;


  isProcessing = true;

  if (!skipLoader) startLoader();

  // Reset idle cart expiry timer on any cart mutation
  var _exp = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = 'cartx_last_active=' + Date.now() + '; expires=' + _exp + '; path=/; SameSite=Lax';
  if (typeof window._resetCartIdleTimer === 'function') window._resetCartIdleTimer();

  const allProducts = {};

  const rawMetaobject = JSON.parse(document.body.getAttribute("metaobject"));
  const filteredObjects = rawMetaobject;
  const cartFreebie = cleanData(
    JSON.parse(document.body.getAttribute("cartfreebie"))
  );
  
  

  // Get BOGO offer variant IDs to exclude them from freebie removal.
  // Only include variants from offers whose time window is currently active.
  let bogoOfferVariantIds = [];
  try {
    const bogoRaw = document.body.getAttribute("bogooffers");
    if (bogoRaw) {
      const bogoOffers = JSON.parse(bogoRaw);
      bogoOffers.forEach(offer => {
        if (offer.offer_products) {
          bogoOfferVariantIds = bogoOfferVariantIds.concat(offer.offer_products.map(id => String(id)));
        }
      });
    }
  } catch (e) {
  }

  // Build set of all GWP gift variant IDs to exclude from freebie removal
  const gwpGiftVariantIds = new Set();
  (rawMetaobject || []).forEach(offer => {
    (offer.get_y || []).forEach(id => {
      gwpGiftVariantIds.add(String(id).split('/').pop());
    });
  });

  // Variants in BOTH BOGO and GWP manage — GWP takes priority, never remove these
  const sharedBogoGwpVariants = new Set();
  bogoOfferVariantIds.forEach(id => {
    if (gwpGiftVariantIds.has(id)) sharedBogoGwpVariants.add(id);
  });

  // Build set of freebie variant IDs that should be kept based on cartFreebie rules
  // This prevents the flickering issue where freebies are removed then re-added
  let freebieVariantsToKeep = new Set();
  cartFreebie?.forEach(({ freebie, products }) => {
    if (freebie.length > 0) {
      const freebieVariantId = freebie[0];
      // Check if any triggering product is in the cart
      const hasTriggeredProduct = products.some(productId => {
        const cartItem = user_cart?.items?.find(item => String(item.variant_id) === productId);
        return cartItem && cartItem.quantity > 0;
      });
      if (hasTriggeredProduct) {
        freebieVariantsToKeep.add(freebieVariantId);
      }
    }
  });

  let claimGift = JSON.parse(document.body.getAttribute("claimgift"));
  let claimGiftLimit = 1;
  if (claimGift) {
    claimGiftLimit = claimGift[0]?.gift_limit || 1;
  }



  let localStorageClaimGift = JSON.parse(
    localStorage.getItem("claimedGiftProducts")
  ) || {};



  const cartUpdatedObject = {};
  let totalFreeProduct = 0;
  let totalFreeProductPrice = 0;
  let totalCombosQuantity = 0;
  let totalCombosPrice = 0;

  let isClaimedGift = false;

  user_cart?.items.forEach(
    ({
      id,
      quantity,
      final_line_price,
      original_line_price,
      product_type,
      properties,
    }) => {
      const productId = id.toString();

      allProducts[productId] = Number(allProducts[productId] || 0) + quantity;

      if (!cartUpdatedObject[productId])
        cartUpdatedObject[productId] = quantity;

      if (
        (final_line_price === freeGiftPrice && original_line_price === freeGiftPrice) ||
        (final_line_price === 0 && original_line_price === 0)
      ) {
        totalFreeProduct++;
        totalFreeProductPrice += final_line_price;
        // Don't remove BOGO offer products, claimed gifts, active freebies, or GWP gifts
        const isBogoProduct = bogoOfferVariantIds.includes(productId);
        const isActiveFreebie = freebieVariantsToKeep.has(productId);
        const isGwpGift = gwpGiftVariantIds.has(productId);
        if (properties?.claimed_gift !== "true" && !isBogoProduct && !isActiveFreebie && !isGwpGift) {
          cartUpdatedObject[productId] = 0;
        }
      }

      if (product_type === "Combos") {
        totalCombosQuantity += quantity;
        totalCombosPrice += final_line_price;
      }

      if (product_type === "Footwear") {
        totalFootwearQty += quantity;
      }

      if (product_type != "Footwear" && product_type != "") {
        totalApparelPrice += final_line_price;
      }
    }
  );


  const cartTotalProductWithoutFreebie =
    user_cart?.item_count - totalFreeProduct - totalCombosQuantity;
  const cartTotalPriceWithoutFreebie =
    user_cart?.total_price - totalFreeProductPrice - totalCombosPrice;

  let totalQuantity = 0;
  let totalPrice = 0;

  let claimedGiftProducts = {};



  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.replace_variant) {

      const replaceId = variant.replace_variant;

      // Find the quantity & price of the current cart item being replaced
      const matchedItems = user_cart?.items.filter(
        (item) => item.id.toString() === replaceId
      );


      const itemWithSpecificPrice = matchedItems?.find(
        (item) => Number(item.final_price) === Number(variant?.final_price)
      );


      if (itemWithSpecificPrice) {
        const oldQty = itemWithSpecificPrice.quantity;
        const oldPrice = itemWithSpecificPrice.final_line_price;

        // Reduce totals to offset the old variant being removed
        totalQuantity -= oldQty;
        totalPrice -= oldPrice;

        // Mark the old variant for removal
        cartUpdatedObject[replaceId] = 0;
      }

    }

    if (variant?.type !== "Combos" && variant?.claimed_gift !== "true") {
      totalQuantity += variant?.quantity;
      totalPrice += variant?.price * variant?.quantity;
    }

    if (variant?.claimed_gift === "true") {

      localStorageClaimGift[key] = event === "CLAIM_ADD" ? variant?.quantity : 0;
    }
  });




  if (Object.entries(localStorageClaimGift)?.length > 0) {
    const existingClaimGift = Object.values(localStorageClaimGift).filter(value => value > 0).length;
    if (existingClaimGift <= claimGiftLimit) {
      localStorage.setItem(
        "claimedGiftProducts",
        JSON.stringify(localStorageClaimGift)
      );
    }
    else {
      showMessage("You can only claim up to " + claimGiftLimit + " gifts", true);
      isProcessing = false;

      stopLoader();
      return;
    }

  }

  const adjustedCartQuantity =
    cartTotalProductWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalQuantity
      : event === "REMOVE" || event == "REMOVE PROTECTOR"
        ? -totalQuantity
        : 0);

  const adjustedCartPrice =
    cartTotalPriceWithoutFreebie +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE" || event == "REMOVE PROTECTOR"
        ? -totalPrice
        : 0);

  const discountPriceCheck =
    user_cart?.total_price +
    (event === "ADD" || event == "MULTI_ADD"
      ? totalPrice
      : event === "REMOVE" || event == "REMOVE PROTECTOR"
        ? -totalPrice
        : 0);

  let deltaFootwearQty = 0;

  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.type === "Footwear") {
      if (event === "ADD") {
        deltaFootwearQty += variant.quantity;
      } else if (event === "MULTI_ADD") {
        deltaFootwearQty += 1;
      } else if (event === "REMOVE" || event == "REMOVE PROTECTOR") {
        deltaFootwearQty -= variant.quantity;
      }
    }
  });
  const adjustFootwearQty = totalFootwearQty + deltaFootwearQty;

  let deltaApparelPrice = 0;
  Object.entries(variantObject).forEach(([key, variant]) => {
    if (variant?.type != "Footwear" && variant?.type != "") {
      if (event === "ADD") {
        deltaApparelPrice += variant.price * variant.quantity;
      } else if (event === "REMOVE" || event == "REMOVE PROTECTOR") {
        deltaApparelPrice -= variant.price * variant.quantity;
      }
    }
  });
  var adjustApparelPrice = totalApparelPrice + deltaApparelPrice;

  // Find applicable rule
  const applicableRule = getApplicableRule(
    filteredObjects,
    adjustedCartQuantity,
    adjustedCartPrice
  );

  // Build GWP variant set early — needed for digital-only detection below.
  const allGwpVariantIds = (rawMetaobject || [])
    .filter(offer => offer.get_y && offer.get_y.length > 0)
    .flatMap(offer => offer.get_y.map(id => String(id).split("/").pop()));

  const activeGwpVariantIds = applicableRule?.get_y
    ? applicableRule.get_y.map(id => String(id).split("/").pop())
    : [];

  // Does the cart contain at least one shippable, non-GWP item AFTER this event?
  // Returning true means it's safe to attach a physical GWP — the order ships anyway.
  // Returning false (digital-only result) means we MUST NOT attach a GWP or Shopify will
  // force a shipping fee onto an order that otherwise ships nothing (e.g. only gift cards).
  // For items being added, requires_shipping=false is treated as digital; any other value
  // (true, undefined, missing) defaults to shippable. So unknown add-to-cart paths fall back
  // to the post-update enforcement in computeGwpThresholdRemovals().
  const gwpSet = new Set(allGwpVariantIds.map(String));
  const removingQty = {};
  if (event === "REMOVE" || event === "REMOVE PROTECTOR") {
    Object.entries(variantObject || {}).forEach(([id, v]) => {
      removingQty[String(id)] = (v?.quantity || 0);
    });
  }
  let willHaveShippableItems = false;
  (user_cart?.items || []).forEach(item => {
    if (willHaveShippableItems) return;
    const variantId = String(item.variant_id);
    if (gwpSet.has(variantId)) return;
    const remaining = item.quantity - (removingQty[variantId] || 0);
    if (remaining <= 0) return;
    if (item.requires_shipping !== false) willHaveShippableItems = true;
  });
  if (!willHaveShippableItems && (event === "ADD" || event === "MULTI_ADD")) {
    Object.entries(variantObject || {}).forEach(([id, v]) => {
      if (willHaveShippableItems) return;
      if (gwpSet.has(String(id))) return;
      if (!v || (v.quantity || 0) <= 0) return;
      if (v.requires_shipping !== false) willHaveShippableItems = true;
    });
  }

  // Only auto-add get_y items on explicit user actions, not on page load.
  // Prevents re-adding manually removed promotional items on back navigation.
  // Also skip when the resulting cart will be digital-only — no shippable item means
  // no shipping line, and we don't want a physical GWP to retroactively add one.
  if (applicableRule?.get_y?.length && event !== undefined && willHaveShippableItems) {
    applicableRule.get_y.forEach((variant) => {
      cartUpdatedObject[variant.split("/").pop()] = 1;
    });
  }

  // Check if any GWP is in cart that shouldn't be there.
  // Remove GWP if: (a) it's not from the current applicable rule (expired/below threshold), OR
  //                (b) the resulting cart is digital-only (would otherwise force shipping).
  if (user_cart?.items) {
    user_cart.items.forEach(item => {
      const variantId = String(item.variant_id);
      const isGwpVariant = allGwpVariantIds.includes(variantId);
      const isActiveGwp = activeGwpVariantIds.includes(variantId);

      if (isGwpVariant && (!isActiveGwp || !willHaveShippableItems) && !sharedBogoGwpVariants.has(variantId)) {
        cartUpdatedObject[variantId] = 0;
      }
    });
  }

  //Claim Gift Logic
  // Check if the gift is claimed


  const applicableRuleClaimGift = getApplicableRule(
    claimGift,
    adjustedCartQuantity,
    adjustedCartPrice
  );

  if (applicableRuleClaimGift && willHaveShippableItems) {
    if (applicableRuleClaimGift?.gift_products?.length) {
      if (localStorageClaimGift) {
        applicableRuleClaimGift.gift_products.forEach((variant) => {
          var variantId = variant.split("/").pop();
          if (localStorageClaimGift.hasOwnProperty(variantId)) {
            cartUpdatedObject[variantId] = localStorageClaimGift[variantId];
          }
        });
      }
    }
  } else {
    // Clear any previously-claimed gift state when no rule applies OR cart is digital-only.
    // Digital-only carts must not re-add a physical claim gift (would force shipping).
    if (!applicableRuleClaimGift) {
      localStorage.removeItem("claimedGiftProducts");
    }
    if (applicableRuleClaimGift?.gift_products?.length && !willHaveShippableItems) {
      applicableRuleClaimGift.gift_products.forEach((variant) => {
        const variantId = variant.split("/").pop();
        const inCart = user_cart?.items?.some(item => String(item.variant_id) === variantId);
        if (inCart) cartUpdatedObject[variantId] = 0;
      });
    }
  }


  // Update cart quantities based on event
  
  
  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const currentQty = cartUpdatedObject[productId] || 0;
    const currentQuantiyAll = allProducts[productId] || 0;
    const newQty = event === "ADD"
        ? currentQty + quantity
        : event === "MULTI_ADD"
          ? 1
          : event === "REMOVE" || event == "REMOVE PROTECTOR"
            ? Math.max(0, currentQty - quantity)
            : currentQty;
    
    
    
    cartUpdatedObject[productId] = newQty;

    allProducts[productId] =
      event === "ADD"
        ? currentQuantiyAll + quantity
        : event === "MULTI_ADD"
          ? 1
          : event === "REMOVE" || event == "REMOVE PROTECTOR"
            ? Math.max(0, currentQty - quantity)
            : currentQty;
  });

  // Apply freebie rules - check if ANY triggering product remains in cart
  
  cartFreebie?.forEach(({ freebie, products }) => {
    if (freebie.length > 0) {
      const freebieVariantId = freebie[0];
      // Check if any of the triggering products are still in the cart (qty > 0)
      const hasTriggeredProduct = products.some((productId) => {
        return cartUpdatedObject[productId] && cartUpdatedObject[productId] > 0;
      });
      
      if (hasTriggeredProduct) {
        // Only auto-add the freebie when triggered by a user action (event is defined),
        // not on page load (event === undefined). This prevents re-adding freebies
        // that the user manually removed when navigating back.
        if (event !== undefined) {
          cartUpdatedObject[freebieVariantId] = 1;
        }
      } else {
        // Remove the freebie if no triggering products remain
        // Only set to 0 if the freebie is currently in cart
        const freebieInCart = user_cart?.items?.some(item => String(item.variant_id) === String(freebieVariantId));
        if (freebieInCart) {

          cartUpdatedObject[freebieVariantId] = 0;
        }
      }
    }
  });

  // --- BOGO AUTO-ADD: DISABLED for large collections ---\n  // Client-side BOGO calculation has been disabled because:\n  // 1. Collections with 2000+ products can't be fully enumerated client-side\n  // 2. The trigger_collection_id approach requires knowing which collections each cart item belongs to\n  // 3. The syncUnlockedGiftsWithCart() function handles this correctly using server-rendered unlock state\n  // The server-side Liquid templates correctly check collection membership for all products.\n  // --- BOGO AUTO-ADD: end ---

  // for footwear ---- start
  const footwearProtectIdInt = parseInt(footwearProtectId);
  // Check if this variant is already in the cart
  const isFootwearProtectInCart = user_cart?.items?.some(
    (item) => item.id === footwearProtectIdInt
  );
  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == footwearProtectIdInt);
    quantity = cartItem ? cartItem.quantity : 0;
  }
  if (footwearProtectId) {
    if (event === "ADD") {
      const wrapper = document.querySelector("#protectorVariantSelect");

      [...wrapper?.options].forEach(opt => {
        if (opt.value !== "0" && opt.value != footwearProtectIdInt) {
          cartUpdatedObject[opt.value] = 0;
        }
      });
    }
  }
  if (footwearProtectId && isFootwearProtectInCart) {
    if (event === "REMOVE PROTECTOR") {
      cartUpdatedObject[footwearProtectId] = 0;
    } else {
      cartUpdatedObject[footwearProtectId] = adjustFootwearQty;
    }



  }

  // for apparel ---- start
  const apparelProtectIdInt = parseInt(apparelProtectId);
  // Check if this variant is already in the cart
  const isApparelProtectInCart = user_cart?.items?.some(
    (item) => item.id === apparelProtectIdInt
  );
  if (user_cart?.items) {
    const cartItem = user_cart.items.find(item => item.variant_id == apparelProtectIdInt);
    quantity = cartItem ? cartItem.quantity : 0;
  }
  if (apparelProtectId) {
    if (event === "ADD") {
      const wrapper = document.querySelector("#apparelProtectorVariantSelect");

      [...wrapper?.options].forEach(opt => {
        if (opt.value !== "0" && opt.value != apparelProtectIdInt) {
          cartUpdatedObject[opt.value] = 0;
        }
      });
    }
  }
  if (apparelProtectId && isApparelProtectInCart) {
    if (event === "REMOVE PROTECTOR") {
      cartUpdatedObject[apparelProtectId] = 0;
    }
  }

  // --- BOGO AUTO-ADD: DISABLED ---
  // This logic has been disabled because it conflicts with syncUnlockedGiftsWithCart()
  // which handles gift syncing after section reload using the server-rendered unlock state.
  // The syncUnlockedGiftsWithCart function is more reliable as it uses the actual
  // cart state and server-calculated unlock thresholds.
  // --- BOGO AUTO-ADD: end ---


  if (checkExceedLimit(allProducts, 500)) {
    showExceedingMessage("You can only add up to 500 of the same item");
    updateQuantity(variantObject, null);
    stopLoader();
    isProcessing = false;

    return;
  }

  const apparel_wrapper = document.querySelector("#apparelProtectorVariantSelect");
  var apparel_protect_data_container = document.getElementById("apparel_protect_data_container");

  if (apparel_protect_data_container) {
    var adjustApparelPrice = adjustApparelPrice / 100;
    const trigger_limit_1 = 250;
    const trigger_limit_2 = 500;

    const apparel_protector_products_wrap = document.querySelectorAll('#apparel_protect_data_container > div');
    let all_apparel_protector_variant_ids = [];
    apparel_protector_products_wrap.forEach(div => {
      all_apparel_protector_variant_ids.push(div.getAttribute("data-variant-1-id")); // lite
      all_apparel_protector_variant_ids.push(div.getAttribute("data-variant-2-id")); // flex
      all_apparel_protector_variant_ids.push(div.getAttribute("data-variant-3-id")); // plus
    });

    if (adjustApparelPrice == 0 || adjustApparelPrice <= 0) {
      all_apparel_protector_variant_ids.forEach(id => {
        if (cartUpdatedObject[id]) {
          cartUpdatedObject[id] = 0;
        }
      });
    }

    const current_apparel_variant_id = all_apparel_protector_variant_ids.find(id => cartUpdatedObject[id]);
    const current_variant_index = all_apparel_protector_variant_ids.indexOf(current_apparel_variant_id);

    let price_tier_index = 0; // default to tier 1 (0-250)

    if (adjustApparelPrice > 0 && adjustApparelPrice <= trigger_limit_1) {
      price_tier_index = 0; // First div (tier 1)
    } else if (adjustApparelPrice > trigger_limit_1 && adjustApparelPrice <= trigger_limit_2) {
      price_tier_index = 1; // Second div (tier 2)
    } else if (adjustApparelPrice > trigger_limit_2) {
      price_tier_index = 2;
    }

    const target_tier_div = apparel_protector_products_wrap[price_tier_index];
    const tier_lite_variant = target_tier_div?.getAttribute("data-variant-1-id");
    const tier_flex_variant = target_tier_div?.getAttribute("data-variant-2-id");
    const tier_plus_variant = target_tier_div?.getAttribute("data-variant-3-id");


    if (current_apparel_variant_id && current_variant_index !== -1) {

      const plan_type_index = current_variant_index % 3;
      let target_variant_id;

      if (plan_type_index === 0) {
        target_variant_id = tier_lite_variant;
      } else if (plan_type_index === 1) {
        target_variant_id = tier_flex_variant;
      } else if (plan_type_index === 2) {
        target_variant_id = tier_plus_variant;
      }

      all_apparel_protector_variant_ids.forEach(id => {
        if (cartUpdatedObject[id]) {
          cartUpdatedObject[id] = 0;
        }
      });

      if (target_variant_id) {
        cartUpdatedObject[target_variant_id] = 1;
      }
    }
  }

  const finalPayload = { updates: cartUpdatedObject };

  const actualChanges = Object.entries(cartUpdatedObject).filter(([variantId, newQty]) => {
    const currentItem = user_cart?.items?.find(i => String(i.variant_id) === variantId);
    const currentQty = currentItem?.quantity || 0;
    return newQty !== currentQty;
  });

  const paidItemWasRemoved = actualChanges.some(([variantId, newQty]) => {
    if (newQty !== 0) return false;
    const cartItem = user_cart?.items?.find(i => String(i.variant_id) === variantId);
    return cartItem && cartItem.price > 0 && !bogoOfferVariantIds.includes(variantId);
  });

  // Fold discount clearing into the main payload to avoid a separate update.js call
  if (paidItemWasRemoved) {
    const manualCodes = (user_cart?.discount_codes || []).filter(
      dc => dc.code && !knownAutomaticCodes.has(dc.code.toUpperCase())
    );
    if (manualCodes.length > 0) {
      finalPayload.discount = "";
      finalPayload.attributes = { appliedDiscountCodes: '' };
    }
  }

  if (actualChanges.length > 0) {

    orgFetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        cache: "no-store",
        priority: "high",
        keepalive: true,
      },
      body: JSON.stringify(finalPayload),
    })
      .then((res) => {
        if (!res.ok) {
          // If we get a 403 or other error, try to continue gracefully
          if (res.status === 403) {
            console.warn('Cart update blocked (403), skipping update');
            stopLoader();
            isProcessing = false;
      
            return null;
          }
          throw new Error(`devx-cartx HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        if (data) {

          user_cart = data;
          isProcessing = false;

          // Discount + attributes already cleared in the main payload above.
          // Just clear the Shopify session cookie if a paid item was removed.
          if (paidItemWasRemoved) {
            const manualCodes = (data.discount_codes || []).filter(
              dc => dc.code && !knownAutomaticCodes.has(dc.code.toUpperCase())
            );
            if (manualCodes.length > 0) {
              const base = getCartBase();
              orgFetch(`${base}discount/CLEAR_INVALID_${Date.now()}`, {
                method: 'GET',
                redirect: 'manual',
                credentials: 'same-origin'
              }).catch(() => {});
            }
          }

          reload_cartx(); // checkDiscountCode is called inside reload_cartx.finally()
          updateQuantity(variantObject, event);
          updateBubble(user_cart?.item_count);
          
          if ((event === "ADD" || event === "MULTI_ADD") && shouldOpenDrawer) {
            const cartDrawer = document.querySelector("cart-drawer");
            if (cartDrawer?.classList.contains("drawer-open") == false) {
              // document.querySelector('.cartx-add-to-cart-popup')?.classList.remove('hide');
              // document.body.classList.remove("overflow-hidden");
              // hideCartOpenTost();
              const cartDrawer = document.querySelector("cart-drawer");
              const overlay = document.querySelector(".cartx-drawer-overlay");
              if (cartDrawer && overlay) {
                cartDrawer.classList.add("drawer-open");
                overlay.classList.add("open-overlay");
              }
              document.body.classList.add("cartx-open");
            }
            // Reset PDP quantity selector to 1 after successful add
            const pdpQuantityInput = document.querySelector('[product-single-form-quantity-value]');
            if (pdpQuantityInput) {
              pdpQuantityInput.value = 1;
              // Also update button states
              const qtyWrapper = pdpQuantityInput.closest('[product-single-form-quantity]');
              if (qtyWrapper) {
                const decBtn = qtyWrapper.querySelector('[product-single-form-quantity-decrement]');
                if (decBtn) decBtn.disabled = true;
              }
            }
          }
        } else {
          // Handle case where update was blocked
          stopLoader();
          isProcessing = false;
    
        }
      })
      .catch(() => {
        stopLoader();
        isProcessing = false;
  
      })
      .finally(() => { });
  } else {
    // No actual quantity changes needed - just refresh UI without calling /cart/update.js
    bindingEvent();
    stopLoader();
    checkDiscountCode(user_cart);
    updateBubble(user_cart?.item_count);
    isProcessing = false;

    // currentDiscountCodes =  user_cart?.attributes?.appliedDiscount.split(',') || [];
  }
}

function checkExceedLimit(object, limit) {
  return Object.values(object).some(value => value > limit);
}

function hideCartOpenTost() {
  setTimeout(function () {
    document.querySelectorAll('.cartx-add-to-cart-popup').forEach(function (el) {
      el.classList.add('hide');
    });
  }, 5000);
}

// Function to clean the cartFreebie data
function cleanData(cartFreebie) {
  return cartFreebie?.map((item) => ({
    freebie: item.freebie.map((id) =>
      id.replace("gid://shopify/ProductVariant/", "")
    ),
    products: item.products.map((id) =>
      id.replace("gid://shopify/ProductVariant/", "")
    ),
  }));
}

function getApplicableRule(
  filteredObjects,
  adjustedCartQuantity,
  adjustedCartPrice
) {
  if (!filteredObjects || !filteredObjects.length) return null;

  const applicableRules = filteredObjects.filter(
    ({ triggered_quantity, trigger_price }) => {
      if (triggered_quantity !== undefined) {
        return adjustedCartQuantity >= triggered_quantity;
      } else if (trigger_price !== undefined) {
        return adjustedCartPrice >= trigger_price * 100;
      }
      return false;
    }
  );

  const sortedRules = applicableRules.sort((a, b) => {
    const aVal =
      a.triggered_quantity !== undefined
        ? a.triggered_quantity
        : a.trigger_price !== undefined
          ? a.trigger_price * 100
          : 0;

    const bVal =
      b.triggered_quantity !== undefined
        ? b.triggered_quantity
        : b.trigger_price !== undefined
          ? b.trigger_price * 100
          : 0;

    return bVal - aVal; // descending
  });

  return sortedRules[0] || null;
}

function reload_cartx(cart_visible = false, event = null, productHandle = null, skipGiftSync = false) {
  const sectionId = "cartx-drawer";

  const currentInner = document.querySelector(
    `#shopify-section-${sectionId} .cartx-drawer-inner`
  );

  const oldBottomCart = document.querySelector(
    `#shopify-section-${sectionId} #cartx-bottom-cart`
  );

  // Mark existing gift cart items as stable BEFORE adding is-loading
  const existingGiftItems = currentInner?.querySelectorAll('.cartx-drawer-product-item.cartx-free-gift-item');
  existingGiftItems?.forEach(item => item.classList.add('cartx-gift-stable'));

  currentInner?.classList.add("is-loading");

  const upsellProductHandle = productHandle || lastAddedProductHandle;
  const upsellParam = upsellProductHandle ? `&upsell_product=${encodeURIComponent(upsellProductHandle)}` : '';
  const cacheBuster = `&_=${Date.now()}`;

  fetch(`/?sections=${sectionId}${upsellParam}${cacheBuster}`, {
    cache: "no-store",
    priority: "high",
    keepalive: true,
  })
    .then((res) => {
      return res.json();
    })
    .then((data) => {
      const updated_cart_html = data[sectionId];

      const parser = new DOMParser();
      const htmlDoc = parser.parseFromString(updated_cart_html, "text/html");
      const newCartInner = htmlDoc.querySelector(".cartx-drawer-inner");
      const bottomCart = htmlDoc.getElementById("cartx-bottom-cart");

      // Update gift section in-place before replacing innerHTML to prevent flash
      updateGiftSectionFromNewHtml(htmlDoc);

      // Store current gift section to preserve it during innerHTML swap
      const currentGiftSection = currentInner.querySelector('.cartx-gift-unlock-section');
      const preservedGiftSection = currentGiftSection ? currentGiftSection.cloneNode(true) : null;

      // Store current gift cart items to preserve them during innerHTML swap
      const currentGiftCartItems = currentInner.querySelectorAll('.cartx-drawer-product-item.cartx-free-gift-item');
      const preservedGiftCartItems = new Map();
      currentGiftCartItems.forEach(item => {
        const variantId = item.getAttribute('data-variant-id');
        if (variantId) {
          preservedGiftCartItems.set(variantId, item.cloneNode(true));
        }
      });

      if (newCartInner && currentInner) {
        currentInner.innerHTML = newCartInner.innerHTML;

        // Restore the preserved gift section to prevent flash
        if (preservedGiftSection) {
          const newGiftSection = currentInner.querySelector('.cartx-gift-unlock-section');
          if (newGiftSection) {
            newGiftSection.replaceWith(preservedGiftSection);
          }
        }

        // Restore preserved gift cart items to prevent visual refresh
        if (preservedGiftCartItems.size > 0) {
          const newGiftCartItems = currentInner.querySelectorAll('.cartx-drawer-product-item.cartx-free-gift-item');
          newGiftCartItems.forEach(newItem => {
            const variantId = newItem.getAttribute('data-variant-id');
            const preserved = preservedGiftCartItems.get(variantId);
            if (preserved) {
              newItem.replaceWith(preserved);
            }
          });
        }

        if (showConfetti) {
          cartConfetti();
        }
        showConfetti = false;

        if (user_cart?.item_count > 0) {
          updateAiUpsell(user_cart?.items);
        }

        currentInner?.querySelectorAll('.cartx-coupon-applied, .cartx-applied-code, .cartx-extra-discounts').forEach(el => {
          el.innerHTML = '';
        });

        bindingEvent();
        loadedEvents();
      }
      if (oldBottomCart && bottomCart) {
        oldBottomCart.innerHTML = bottomCart.innerHTML;
        if (user_cart?.item_count > 0) {
          oldBottomCart.classList.add("show-slide");
        } else {
          oldBottomCart.classList.remove("show-slide");
        }
      }

      // Sync unlocked gifts with cart items
      // Check if any GWP gifts need removing (cart below threshold after discount)
      const gwpRemovals = computeGwpThresholdRemovals();
      if (Object.keys(gwpRemovals).length > 0) {
        orgFetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates: gwpRemovals })
        })
        .then(r => r.ok ? r.json() : null)
        .then(freshCart => {
          if (freshCart) {
            user_cart = freshCart;
            if (typeof updateBubble === 'function') updateBubble(freshCart.item_count);
            reload_cartx(false, null, null, true);
          }
        })
        .catch(() => {});
      }

      const syncResult = syncUnlockedGiftsWithCart(skipGiftSync);

      if (typeof window.reorderGiftItems === 'function') {
        window.reorderGiftItems();
      }

      // Only remove loading state if no sync was triggered
      if (!syncResult) {
        currentInner?.classList.remove("is-loading");
        currentInner?.querySelectorAll('.cartx-gift-stable').forEach(item => {
          item.classList.remove('cartx-gift-stable');
        });
      }
    })
    .catch((error) => {
      console.error("Error reloading cart:", error);
      currentInner?.classList.remove("is-loading");
      currentInner?.querySelectorAll('.cartx-gift-stable').forEach(item => {
        item.classList.remove('cartx-gift-stable');
      });
    })
    .finally(() => {
      stopLoader();
      loadedEvents();
      updateInventoryStates();
      if (typeof checkDiscountCode === 'function') {
        checkDiscountCode(user_cart);
      }
      if (pendingMessage) {
        showMessage(pendingMessage.text, pendingMessage.isError);
        pendingMessage = null;
      }
      scheduleOfferTimers();

    });
}

// Fetches cart drawer section HTML from Shopify section rendering API.
async function fetchSectionHtml(sectionId, upsellParam, cacheBuster) {
  const res = await fetch(`/?sections=${sectionId}${upsellParam}${cacheBuster}`, {
    cache: "no-store",
    priority: "high",
    keepalive: true,
  });
  const data = await res.json();
  return data[sectionId];
}

// Parses fresh section HTML (not live DOM) to determine which BOGO gifts
// need adding or removing. Returns an updates object for /cart/update.js.
// Only returns entries that represent actual changes vs current user_cart.
function computeBogoUpdatesFromHtml(sectionHtml) {
  const updates = {};
  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionHtml, "text/html");

  const cartVariantIds = new Set();
  if (user_cart?.items) {
    user_cart.items.forEach(item => cartVariantIds.add(String(item.variant_id)));
  }

  // Check each BOGO gift item in the freshly rendered HTML
  doc.querySelectorAll('.cartx-gift-item').forEach(giftItem => {
    const offerStartSec = parseInt(giftItem.getAttribute('data-offer-start-time') || '0', 10);
    const offerEndSec = parseInt(giftItem.getAttribute('data-offer-end-time') || '9999999999', 10);
    const nowSec = Math.floor(Date.now() / 1000);
    const isOfferTimeValid = nowSec >= offerStartSec && nowSec <= offerEndSec;

    const isUnlockedByClass = giftItem.classList.contains('cartx-unlocked');
    const isLockedByClass = giftItem.classList.contains('cartx-locked');
    const giftState = giftItem.getAttribute('data-gift-state');
    const isUnlocked = isUnlockedByClass && giftState === 'unlocked' && isOfferTimeValid;
    const isLocked = isLockedByClass || giftState === 'locked' || !isOfferTimeValid;

    const variantId = giftItem.getAttribute('data-variant-id');
    const isGiftAvailable = giftItem.getAttribute('data-gift-available') !== 'false';
    if (!variantId) return;

    const giftInCart = cartVariantIds.has(String(variantId));

    // Unlocked + not in cart → add it
    if (isUnlocked && !giftInCart && isGiftAvailable) {
      updates[variantId] = 1;
    }
    // Locked + in cart → remove it
    if (isLocked && giftInCart) {
      updates[variantId] = 0;
    }
  });

  // Handle expired BOGO offers when no gift section exists in HTML
  if (!doc.querySelector('.cartx-gift-unlock-section')) {
    try {
      const bogoRaw = document.body.getAttribute("bogooffers");
      if (bogoRaw) {
        JSON.parse(bogoRaw).forEach(offer => {
          if (!isBogoOfferTimeValid(offer) && offer.offer_products) {
            offer.offer_products.forEach(varId => {
              const strId = String(varId);
              if (cartVariantIds.has(strId)) updates[strId] = 0;
            });
          }
        });
      }
    } catch (e) {}
  }

  // Filter to actual changes only
  const actualUpdates = {};
  Object.entries(updates).forEach(([variantId, qty]) => {
    const currentItem = user_cart?.items?.find(i => String(i.variant_id) === variantId);
    const currentQty = currentItem?.quantity || 0;
    if (qty !== currentQty) {
      actualUpdates[variantId] = qty;
    }
  });

  return actualUpdates;
}

// Function to update gift section progress bars and state in-place without replacing HTML
function updateGiftSectionFromNewHtml(newHtmlDoc) {
  const currentGiftSection = document.querySelector('.cartx-gift-unlock-section');
  const newGiftSection = newHtmlDoc.querySelector('.cartx-gift-unlock-section');
  
  if (!currentGiftSection || !newGiftSection) {
    return;
  }
  
  // Build a set of variant IDs currently in cart for accurate checking
  const cartVariantIds = new Set();
  if (user_cart?.items) {
    user_cart.items.forEach(item => {
      cartVariantIds.add(String(item.variant_id));
    });
  }
  
  // Update claimed count header
  const currentClaimedCount = currentGiftSection.querySelector('.cartx-claimed-count');
  const newClaimedCount = newGiftSection.querySelector('.cartx-claimed-count');
  if (currentClaimedCount && newClaimedCount) {
    currentClaimedCount.textContent = newClaimedCount.textContent;
  }
  
  // Update each gift item in-place
  const currentGiftItems = currentGiftSection.querySelectorAll('.cartx-gift-item');
  const newGiftItems = newGiftSection.querySelectorAll('.cartx-gift-item');
  
  currentGiftItems.forEach((currentItem, index) => {
    const newItem = newGiftItems[index];
    if (!newItem) return;
    
    const variantId = currentItem.getAttribute('data-variant-id');
    const newVariantId = newItem.getAttribute('data-variant-id');
    
    // Match by variant ID if possible, otherwise by index
    let matchingNewItem = newItem;
    if (variantId !== newVariantId) {
      matchingNewItem = Array.from(newGiftItems).find(item => 
        item.getAttribute('data-variant-id') === variantId
      ) || newItem;
    }
    
    // Check actual cart items for gift-in-cart state (more reliable than server HTML)
    const giftInCart = cartVariantIds.has(String(variantId));
    
    // Update data attributes - use actual cart state for gift-in-cart
    currentItem.setAttribute('data-gift-state', matchingNewItem.getAttribute('data-gift-state'));
    currentItem.setAttribute('data-gift-in-cart', giftInCart ? 'true' : 'false');
    
    // Update classes (locked/unlocked state)
    const wasUnlocked = currentItem.classList.contains('cartx-unlocked');
    const isNowUnlocked = matchingNewItem.classList.contains('cartx-unlocked');
    const isNowLocked = matchingNewItem.classList.contains('cartx-locked');
    // Gift is "added" if it's unlocked AND in cart
    const hasGiftAdded = isNowUnlocked && giftInCart;
    
    currentItem.classList.toggle('cartx-unlocked', isNowUnlocked);
    currentItem.classList.toggle('cartx-locked', isNowLocked);
    currentItem.classList.toggle('cartx-gift-added', hasGiftAdded);
    
    // Update progress bar
    const currentProgressFill = currentItem.querySelector('.cartx-progress-fill');
    const newProgressFill = matchingNewItem.querySelector('.cartx-progress-fill');
    if (currentProgressFill && newProgressFill) {
      currentProgressFill.style.width = newProgressFill.style.width;
    }
    
    // Update locked banner text
    const currentLockedBanner = currentItem.querySelector('.cartx-locked-banner span');
    const newLockedBanner = matchingNewItem.querySelector('.cartx-locked-banner span');
    if (currentLockedBanner && newLockedBanner) {
      currentLockedBanner.textContent = newLockedBanner.textContent;
    }
  });
}

// Function to sync unlocked gifts with cart - auto-add unlocked gifts and remove locked ones
// Returns true if a sync operation was triggered, false otherwise
function syncUnlockedGiftsWithCart(skipAdd = false) {
  
  
  // Prevent infinite loop - if we're already syncing, skip
  if (isSyncingGifts) {
    isSyncingGifts = false;
    return false;
  }

  const giftItems = document.querySelectorAll('.cartx-gift-item');

  if (!giftItems.length) {
    // Reset pending flag since there's nothing to sync
    giftSyncPending = false;
    return false;
  }

  // Build a set of variant IDs currently in cart for accurate checking
  const cartVariantIds = new Set();
  if (user_cart?.items) {
    user_cart.items.forEach(item => {
      cartVariantIds.add(String(item.variant_id));
    });
  }

  // Collect BOGO gift variant ids so the digital-only check can exclude any stranded
  // gift already in the cart when deciding whether the rest of the cart is digital.
  const bogoGiftVariantIds = [];
  document.querySelectorAll('.cartx-gift-item[data-variant-id]').forEach(el => {
    const vid = el.getAttribute('data-variant-id');
    if (vid) bogoGiftVariantIds.push(vid);
  });
  const digitalOnlyCart = cartHasOnlyDigitalItems(user_cart?.items, bogoGiftVariantIds);

  const variantsToAdd = {};
  const variantsToRemove = {};

  giftItems.forEach((giftItem, index) => {
    const isUnlockedByClass = giftItem.classList.contains('cartx-unlocked');
    const isLockedByClass = giftItem.classList.contains('cartx-locked');
    // Double-check unlock state using data attribute (more reliable)
    const giftState = giftItem.getAttribute('data-gift-state');
    const isUnlocked = isUnlockedByClass && giftState === 'unlocked';
    const isLocked = isLockedByClass || giftState === 'locked';

    const variantId = giftItem.getAttribute('data-variant-id');
    const variantPrice = giftItem.getAttribute('data-variant-price');
    const productType = giftItem.getAttribute('data-product-type') || '';
    // Check if the gift product is available (in stock)
    const isGiftAvailable = giftItem.getAttribute('data-gift-available') !== 'false';
    
    if (!variantId) {
      return;
    }

    // Check actual cart items instead of relying on DOM attribute
    const giftInCart = cartVariantIds.has(String(variantId));
    
    // Update the DOM attribute to match actual cart state
    giftItem.setAttribute('data-gift-in-cart', giftInCart ? 'true' : 'false');

    // If unlocked but gift is NOT in cart, add it (only if gift is available/in stock).
    // Skip on digital-only carts — auto-attaching a physical gift would force a shipping
    // line onto an order that should ship nothing (e.g. only a gift card in cart).
    if (isUnlocked && !giftInCart && isGiftAvailable && !digitalOnlyCart) {
      variantsToAdd[variantId] = {
        quantity: 1,
        price: parseInt(variantPrice) || 0,
        type: productType,
      };
    }

    // If locked but gift IS in cart, remove it
    // Skip if variant is in both BOGO and GWP — GWP takes priority
    let isSharedBogoGwp = false;
    try {
      const bogoIds = new Set();
      const br = document.body.getAttribute("bogooffers");
      if (br) JSON.parse(br).forEach(o => (o.offer_products || []).forEach(id => bogoIds.add(String(id))));
      const gwpIds = new Set();
      const meta = JSON.parse(document.body.getAttribute("metaobject")) || [];
      meta.forEach(o => (o.get_y || []).forEach(id => gwpIds.add(String(id).split('/').pop())));
      isSharedBogoGwp = bogoIds.has(variantId) && gwpIds.has(variantId);
    } catch (e) {}

    if (isLocked && giftInCart && !isSharedBogoGwp) {
      variantsToRemove[variantId] = {
        quantity: 1,
        price: parseInt(variantPrice) || 0,
        type: productType,
      };
    }
  });

  // When no gift section exists in the DOM (offer expired or hasn't started yet),
  // remove any BOGO offer products that are still in the cart from a previous session.
  // This handles the case where reload_cartx fetches fresh HTML with no gift section.
  if (!document.querySelector('.cartx-gift-unlock-section')) {
    try {
      const bogoRaw = document.body.getAttribute("bogooffers");
      if (bogoRaw) {
        const bogoOffers = JSON.parse(bogoRaw);
        bogoOffers.forEach(offer => {
          if (!isBogoOfferTimeValid(offer) && offer.offer_products) {
            offer.offer_products.forEach(varId => {
              const strId = String(varId);
              if (cartVariantIds.has(strId)) {
                const cartItem = user_cart?.items?.find(i => String(i.variant_id) === strId);
                variantsToRemove[strId] = {
                  quantity: 1,
                  price: cartItem?.price || 0,
                  type: cartItem?.product_type || '',
                };
              }
            });
          }
        });
      }
    } catch (e) {}
  }

  // Add unlocked gifts that are not in cart — skip on back navigation to avoid
  // re-adding items the user intentionally removed.
  if (!skipAdd && Object.keys(variantsToAdd).length > 0) {
    isSyncingGifts = true;
    giftSyncPending = false;
    cartx(variantsToAdd, "ADD", false);
    return true;
  }

  if (Object.keys(variantsToRemove).length > 0) {
    
    isSyncingGifts = true;
    giftSyncPending = false;
    cartx(variantsToRemove, "REMOVE", false);
    return true;
  }
  
  // No more items to sync - reset flags
  // This means the previous sync operation completed successfully
  isSyncingGifts = false;
  giftSyncPending = false;
  
  return false;
}

// Returns true if cart has items but none require shipping (digital-only, e.g. gift cards).
// GWP variants are excluded so a stranded GWP from a prior add doesn't mask the digital-only state.
function cartHasOnlyDigitalItems(items, gwpVariantIds) {
  if (!items || items.length === 0) return false;
  const gwpSet = new Set((gwpVariantIds || []).map(String));
  const nonGwpItems = items.filter(item => !gwpSet.has(String(item.variant_id)));
  if (nonGwpItems.length === 0) return false;
  return nonGwpItems.every(item => item.requires_shipping === false);
}

// Computes GWP variant removals based on cart value vs threshold.
// Returns an updates object for /cart/update.js (variantId → 0) — does NOT call cartx().
// Used inside fetchSectionAndSyncGifts to remove GWP gifts before DOM update.
function computeGwpThresholdRemovals() {
  if (!user_cart?.items || user_cart.items.length === 0) return {};

  let rawMetaobject = [];
  try {
    rawMetaobject = JSON.parse(document.body.getAttribute("metaobject")) || [];
  } catch (e) {
    return {};
  }

  const filteredObjects = filterGWPByTime(rawMetaobject);

  let totalFreeProductPrice = 0;
  let cartQuantityExcludingFree = 0;

  user_cart.items.forEach(item => {
    const isFree = (item.final_price === 100 && item.original_line_price === 100) ||
                   (item.final_price === 0 && item.original_line_price === 0);
    if (isFree) {
      totalFreeProductPrice += item.final_line_price;
    } else {
      cartQuantityExcludingFree += item.quantity;
    }
  });

  const cartPriceExcludingFree = user_cart.total_price - totalFreeProductPrice;

  const applicableRule = getApplicableRule(
    filteredObjects,
    cartQuantityExcludingFree,
    cartPriceExcludingFree
  );

  const allGwpVariantIds = (rawMetaobject || [])
    .filter(offer => offer.get_y && offer.get_y.length > 0)
    .flatMap(offer => offer.get_y.map(id => String(id).split("/").pop()));

  const activeGwpVariantIds = applicableRule?.get_y
    ? applicableRule.get_y.map(id => String(id).split("/").pop())
    : [];

  // If the cart contains only digital items (no shippable products), strip every GWP variant.
  // Physical GWPs would otherwise force a shipping fee on an order that should ship nothing.
  const digitalOnly = cartHasOnlyDigitalItems(user_cart.items, allGwpVariantIds);

  const updates = {};

  user_cart.items.forEach(item => {
    const variantId = String(item.variant_id);
    const isGwpVariant = allGwpVariantIds.includes(variantId);
    const isActiveGwp = activeGwpVariantIds.includes(variantId);

    if (isGwpVariant && (digitalOnly || !isActiveGwp)) {
      updates[variantId] = 0;
    }
  });

  return updates;
}

// Function to check and remove GWP items from gift_manage metaobject when cart value
// falls below threshold (e.g., after coupon application reduces cart total)
// Returns true if a removal was triggered, false otherwise
function syncGwpWithCartValue() {
  if (!user_cart?.items || user_cart.items.length === 0) return false;
  
  // Get GWP offers from metaobject
  let rawMetaobject = [];
  try {
    rawMetaobject = JSON.parse(document.body.getAttribute("metaobject")) || [];
  } catch (e) {
    return false;
  }
  
  // Filter by time to get currently active offers
  const filteredObjects = filterGWPByTime(rawMetaobject);
  
  // Calculate cart totals (excluding freebies)
  let totalFreeProductPrice = 0;
  let cartQuantityExcludingFree = 0;
  
  user_cart.items.forEach(item => {
    const isFree = (item.final_price === 100 && item.original_line_price === 100) ||
                   (item.final_price === 0 && item.original_line_price === 0);
    if (isFree) {
      totalFreeProductPrice += item.final_line_price;
    } else {
      cartQuantityExcludingFree += item.quantity;
    }
  });
  
  // Use total_price which includes discounts
  const cartPriceExcludingFree = user_cart.total_price - totalFreeProductPrice;
  
  // Find applicable rule based on current cart state (after discounts)
  const applicableRule = getApplicableRule(
    filteredObjects,
    cartQuantityExcludingFree,
    cartPriceExcludingFree
  );
  
  // Get all GWP variant IDs from all metaobject offers
  const allGwpVariantIds = (rawMetaobject || [])
    .filter(offer => offer.get_y && offer.get_y.length > 0)
    .flatMap(offer => offer.get_y.map(id => String(id).split("/").pop()));
  
  // Get the active applicable rule's GWP variants (if any)
  const activeGwpVariantIds = applicableRule?.get_y
    ? applicableRule.get_y.map(id => String(id).split("/").pop())
    : [];

  // Digital-only carts (e.g. only gift cards) must strip every GWP variant —
  // a physical gift would otherwise force shipping on an order that should ship nothing.
  const digitalOnly = cartHasOnlyDigitalItems(user_cart.items, allGwpVariantIds);

  // Find GWP items in cart that should be removed
  const variantsToRemove = {};

  user_cart.items.forEach(item => {
    const variantId = String(item.variant_id);
    const isGwpVariant = allGwpVariantIds.includes(variantId);
    const isActiveGwp = activeGwpVariantIds.includes(variantId);

    // Remove if: 1) not from the current applicable rule (expired/below threshold), OR
    //            2) cart contains only digital products and shouldn't trigger shipping.
    if (isGwpVariant && (digitalOnly || !isActiveGwp)) {
      variantsToRemove[variantId] = {
        quantity: 1,
        price: item.price || 0,
        type: item.product_type || '',
      };
    }
  });

  // Remove GWP items that no longer meet threshold
  if (Object.keys(variantsToRemove).length > 0) {
    cartx(variantsToRemove, "REMOVE", false);
    return true;
  }

  return false;
}

function updateQuantity(variantObject = {}, event) {
  if (!variantObject) return;

  Object.entries(variantObject).forEach(([productId, { quantity }]) => {
    const quantityElements = document.querySelectorAll(
      '.cartx-atc-qty[data-variant-id="' + productId + '"]'
    );

    const quantityElementsWrapper = document.querySelectorAll(
      '.cartx-product-button-wrap[data-variant-id="' + productId + '"]'
    );

    quantityElementsWrapper?.forEach((element) => {
      const el = element.querySelector(".cartx-atc-qty");

      if (el) {
        const addToCart = element.querySelector(".cartx-add-to-cart");
        const plusMinusWrapper = element.querySelector(".cartx-add-to-cart-qty-wrap");

        if (event) {
          if (event == 'CHANGE') {
            el.value = Number(quantity);
          }
          else {
            el.value =
              Number(el?.value) +
              (event === "ADD" || event == "MULTI_ADD" ? 1 : -1) * Number(quantity);
          }
        }

        if (Number(el.value) > 0) {
          addToCart.style.display = "none";
          plusMinusWrapper.style.display = "flex";
        } else {
          addToCart.style.display = "flex";
          plusMinusWrapper.style.display = "none";
        }


      }
      // Always remove loading state, even if event is not found
      if (element.classList.contains("cartx-button-loadding")) {
        element.classList.remove("cartx-button-loadding");
        // Reset button text and loader visibility
        const atcButton = element.querySelector('.cartx-add-to-cart');
        const loader = atcButton?.querySelector('.cartx-atc-loading');
        if (atcButton && loader) {
          atcButton.querySelector('span')?.classList.remove('hide');
          loader.style.display = 'none';
        }
      }
    });
  });
}


// Helper function to calculate cart count excluding GIFT type products
function getCartCountExcludingGifts() {
  if (!user_cart?.items) return 0;
  
  let count = 0;
  user_cart.items.forEach((item) => {
    // Exclude products with product_type "GIFT"
    if (item.product_type !== "GIFT") {
      count += item.quantity;
    }
  });
  return count;
}

function updateBubble(cartCount) {
  // Use the filtered count that excludes GIFT products
  const filteredCount = getCartCountExcludingGifts();
  
  // Update header cart count elements
  const bubbleElements = document.querySelectorAll("[header-cart-item-count]");
  bubbleElements.forEach((bubble) => {
    // update the attribute itself as well as the visible text
    try {
      bubble.setAttribute('header-cart-item-count', String(filteredCount));
    } catch (e) {
      /* ignore */
    }
    bubbleCount(bubble, filteredCount);
  });
  
  // Update cart drawer item count element
  const drawerCountElements = document.querySelectorAll(".cartx-drawer-item-count");
  drawerCountElements.forEach((el) => {
    el.textContent = filteredCount;
    el.setAttribute('data-count', String(filteredCount));
  });
}

function bubbleCount(bubble, cartCount) {
  if (!bubble) return;
  const hiddenCount = bubble.querySelector(".visually-hidden");
  try {
    bubble.setAttribute('header-cart-item-count', String(cartCount));
  } catch (e) {
    /* ignore */
  }

  if (bubble) bubble.textContent = cartCount;
  if (hiddenCount) hiddenCount.textContent = `${cartCount} items`;
}

// Function to update inventory states across the site
function updateInventoryStates(specificVariantId = null) {
  // Update all ATC button wrappers (or specific variant if provided)
  const selector = specificVariantId 
    ? `.cartx-product-button-wrap[data-variant-id="${specificVariantId}"]`
    : '.cartx-product-button-wrap';
    
  const wrappers = document.querySelectorAll(selector);
  wrappers.forEach((wrapper) => {
    const variantId = wrapper.getAttribute('data-variant-id');
    
    // Fix: Handle inventory attribute properly - 0 is a valid value, not falsy
    const inventoryAttr = wrapper.getAttribute('data-inventory');
    const maxInventory = inventoryAttr !== null && inventoryAttr !== '' ? parseInt(inventoryAttr, 10) : 9999;
    
    // Fix: Check data-available more carefully
    const availableAttr = wrapper.getAttribute('data-available');
    const isAvailable = availableAttr !== 'false' && availableAttr !== '0';
    
    // Only use server-side sold out state on initial page load (no specific variant passed)
    // When a specific variant is passed (variant changed), ignore server-side classes
    // and rely solely on data attributes
    const hasServerSideSoldOut = !specificVariantId && 
      (wrapper.classList.contains('cartx-button-soldout') || wrapper.classList.contains('cartx-sold-out'));
    
    // Find current quantity in cart for this variant (handle null cart)
    let currentQtyInCart = 0;
    if (user_cart?.items) {
      const cartItem = user_cart.items.find(item => String(item.variant_id) === String(variantId));
      currentQtyInCart = cartItem ? cartItem.quantity : 0;
    }
    
    // Update the data-in-cart attribute
    wrapper.setAttribute('data-in-cart', currentQtyInCart);
    
    // Get ATC button
    const atcButton = wrapper.querySelector('.cartx-add-to-cart');
    if (!atcButton) {
      return;
    }
    
    // Always reset all states first
    atcButton.classList.remove('cartx-sold-out', 'cartx-max-stock');
    wrapper.classList.remove('cartx-button-soldout');
    atcButton.removeAttribute('disabled');
    
    // Check if variant is sold out (zero inventory or not available or server-side marked as sold out)
    const isSoldOut = maxInventory === 0 || !isAvailable || hasServerSideSoldOut;
    
    if (isSoldOut) {
      // Product is sold out
      atcButton.classList.add('cartx-sold-out');
      wrapper.classList.add('cartx-button-soldout');
      atcButton.setAttribute('disabled', 'disabled');
      const span = atcButton.querySelector('span');
      if (span) span.textContent = 'Sold Out';
    } else {
      // Check if at max inventory in cart
      const isAtMax = currentQtyInCart >= maxInventory && maxInventory !== 9999;
      
      if (isAtMax) {
        // Max stock reached in cart
        atcButton.classList.add('cartx-max-stock');
        atcButton.setAttribute('disabled', 'disabled');
        const span = atcButton.querySelector('span');
        if (span) span.textContent = 'MAX PRODUCT LIMIT';
      } else {
        // Available to add to cart
        atcButton.classList.remove('cartx-max-stock');
        atcButton.removeAttribute('disabled');
        const span = atcButton.querySelector('span');
        if (span) {
          // Get original text - prefer data attribute, fallback to 'Add to bag'
          const originalText = atcButton.getAttribute('data-original-text') || wrapper.getAttribute('data-add-text') || 'Add to bag';
          span.textContent = originalText;
        }
      }
    }
  });

  // Update PDP quantity selector based on current cart state
  const pdpQtyWrapper = document.querySelector('[product-single-form-quantity]');
  if (pdpQtyWrapper) {
    const pdpQtyInput = pdpQtyWrapper.querySelector('[product-single-form-quantity-value]');
    const pdpIncBtn = pdpQtyWrapper.querySelector('[product-single-form-quantity-increment]');
    const pdpDecBtn = pdpQtyWrapper.querySelector('[product-single-form-quantity-decrement]');
    const variantIdInput = document.querySelector('[product-single-form-variant-id]');
    
    if (pdpQtyInput && variantIdInput) {
      const currentVariantId = variantIdInput.value;
      const pdpWrapper = document.querySelector(`.cartx-product-button-wrap[data-variant-id="${currentVariantId}"]`);
      const maxInventory = pdpWrapper ? parseInt(pdpWrapper.getAttribute('data-inventory')) || 9999 : 9999;
      
      // Find current quantity in cart for this variant (handle null cart)
      let currentQtyInCart = 0;
      if (user_cart?.items) {
        const cartItem = user_cart.items.find(item => String(item.variant_id) === String(currentVariantId));
        currentQtyInCart = cartItem ? cartItem.quantity : 0;
      }
      
      // Calculate remaining quantity that can be added
      const remainingQty = maxInventory === 9999 ? 9999 : Math.max(0, maxInventory - currentQtyInCart);
      
      // Update max data attribute
      pdpQtyInput.dataset.max = remainingQty;
      
      // Get current input value
      const currentInputQty = parseInt(pdpQtyInput.value, 10) || 1;
      
      // Update button states
      if (pdpIncBtn) {
        pdpIncBtn.disabled = currentInputQty >= remainingQty && remainingQty !== 9999;
      }
      if (pdpDecBtn) {
        pdpDecBtn.disabled = currentInputQty <= 1;
      }
    }
  }

  // Update cart drawer quantity plus buttons (or specific variant if provided)
  const drawerSelector = specificVariantId 
    ? `.cartx-drawer-product-item[data-variant-id="${specificVariantId}"][data-inventory]`
    : '.cartx-drawer-product-item[data-inventory]';
    
  document.querySelectorAll(drawerSelector).forEach((li) => {
    const variantId = li.getAttribute('data-variant-id');
    const maxInventory = parseInt(li.getAttribute('data-inventory')) || 9999;
    
    // Find current quantity in cart for this variant (handle null cart)
    let currentQtyInCart = 0;
    if (user_cart?.items) {
      const cartItem = user_cart.items.find(item => String(item.variant_id) === String(variantId));
      currentQtyInCart = cartItem ? cartItem.quantity : 0;
    }
    
    // Update data-current-qty attribute
    li.setAttribute('data-current-qty', currentQtyInCart);
    
    // Check if at max inventory
    const isAtMax = currentQtyInCart >= maxInventory && maxInventory !== 9999;
    
    // Update plus button state
    const plusButton = li.querySelector('.cartx-drawer-product-quantity-button[name="plus"]');
    if (plusButton) {
      if (isAtMax) {
        plusButton.setAttribute('disabled', 'disabled');
      } else {
        plusButton.removeAttribute('disabled');
      }
    }
  });
}

function applyCode(codeInput = null) {
  const code = (
    codeInput || document.querySelector(".prv-coupon-input")
  ).value.trim();

  applyDiscount(user_cart?.token, code);
}

// Validate discount code format
function validateDiscountCode(code) {
  // Basic validation - adjust pattern as needed
  return code.replace(/[^\w\-]/g, "");
}

// Get the cart base URL (Shopify routes)
function getCartBase() {
  return window.Shopify?.routes?.root || '/';
}

// Extract all applied discount codes from a cart object
// Returns array of code strings (uppercase)
function getAppliedCodesFromCart(cart) {
  const codes = new Set();
  
  // From cart-level discount applications
  if (cart?.cart_level_discount_applications) {
    cart.cart_level_discount_applications
      .filter(d => d.type === 'discount_code' || d.discount_application?.type === 'discount_code')
      .forEach(d => {
        const title = d.title || d.discount_application?.title;
        if (title) codes.add(title.toUpperCase());
      });
  }
  
  // From line-level discount allocations on each item
  if (cart?.items) {
    cart.items.forEach(item => {
      if (item.line_level_discount_allocations) {
        item.line_level_discount_allocations
          .filter(a => a.discount_application?.type === 'discount_code')
          .forEach(a => {
            const title = a.discount_application?.title;
            if (title) codes.add(title.toUpperCase());
          });
      }
    });
  }
  
  // From cart attributes (applied via /discount/CODE endpoint, stored for UI tracking)
  const attrCodes = cart?.attributes?.appliedDiscountCodes;
  if (attrCodes) {
    attrCodes.split(',').forEach(code => {
      const trimmed = code.trim().toUpperCase();
      if (trimmed) codes.add(trimmed);
    });
  }
  
  return [...codes];
}

// Check if a specific discount code is applied on the cart (case-insensitive)
function isDiscountAppliedOnCart(cart, code) {
  if (!code) return false;
  const appliedCodes = getAppliedCodesFromCart(cart);
  return appliedCodes.includes(code.toUpperCase());
}

// Sync cart attributes with actual applied discounts
// This clears stale appliedDiscountCodes if discounts were removed at checkout
// Returns a Promise that resolves when sync is complete
function syncDiscountAttributes(cart) {
  // Update knownAutomaticCodes from current cart allocations, then use it for classification.
  // This ensures temporary Shopify conflict states don't misclassify automatic codes.
  cart?.items?.forEach(item => {
    item.line_level_discount_allocations?.forEach(alloc => {
      if (alloc.discount_application?.type === 'automatic') {
        _persistAutoCode((alloc.discount_application?.title || '').toUpperCase());
      }
    });
  });
  cart?.cart_level_discount_applications?.forEach(app => {
    const type = app.discount_application?.type || app.type;
    if (type === 'automatic') {
      _persistAutoCode((app.discount_application?.title || app.title || '').toUpperCase());
    }
  });

  // Collect all applied codes with correct type info
  const actuallyAppliedCodes = new Set();
  const typedCodesArray = [];
  const seen = new Set();

  const addCode = (codeUpper) => {
    if (!codeUpper || seen.has(codeUpper)) return;
    seen.add(codeUpper);
    actuallyAppliedCodes.add(codeUpper);
    const isAutomatic = knownAutomaticCodes.has(codeUpper);
    typedCodesArray.push({ code: codeUpper, type: isAutomatic ? 'automatic' : 'discount_code', removable: !isAutomatic });
  };

  cart?.items?.forEach(item => {
    item.line_level_discount_allocations?.forEach(alloc => {
      addCode((alloc.discount_application?.title || '').toUpperCase());
    });
  });
  cart?.cart_level_discount_applications?.forEach(app => {
    addCode((app.discount_application?.title || app.title || '').toUpperCase());
  });
  cart?.discount_codes?.forEach(dc => {
    if (dc.code && dc.applicable !== false) addCode(dc.code.toUpperCase());
  });

  // Get stored codes from attributes
  const storedCodesAttr = cart?.attributes?.appliedDiscountCodes || '';
  const storedCodes = storedCodesAttr ? storedCodesAttr.split(',').map(c => c.toUpperCase().trim()).filter(Boolean) : [];

  const actualCodesArray = [...actuallyAppliedCodes];
  const needsSync = storedCodes.length !== actualCodesArray.length ||
    !storedCodes.every(code => actuallyAppliedCodes.has(code));

  if (needsSync) {
    return orgFetch("/cart/update.js", {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { appliedDiscountCodes: actualCodesArray.join(',') } })
    }).then(() => {
      if (user_cart) {
        user_cart.attributes = user_cart.attributes || {};
        user_cart.attributes.appliedDiscountCodes = actualCodesArray.join(',');
      }
      currentDiscountCodes = actualCodesArray;
      return true;
    });
  }
  return Promise.resolve(false);
  // Rendering is handled by reload_cartx().finally() → checkDiscountCode(user_cart)
}

async function applyDiscount(_cartId, discountCode) {
  if (!discountCode) {
    showMessage("Please enter a discount code.", true);
    return;
  }

  if (typeof user_cart === "undefined" || user_cart?.item_count === 0) {
    showMessage("Your cart is empty. Add items before applying a code.", true);
    return;
  }

  const sanitizedCode = validateDiscountCode(discountCode);
  if (!sanitizedCode) {
    showMessage("Invalid discount code format.", true);
    return;
  }

  startLoader();
  showMessage("Applying discount...", false);

  try {
    const base = getCartBase();
    
    // Fetch fresh cart to check actual discount state (not cached)
    const freshCart = await orgFetch(`${base}cart.js`).then(r => r.json());
    user_cart = freshCart;
    
    // Helper function to get all applied discount codes from cart
    const getAppliedDiscountCodes = (cart) => {
      const codes = new Set();
      
      // PRIMARY SOURCE: discount_codes array (most reliable for discount codes)
      cart?.discount_codes?.forEach(dc => {
        if (dc.code && dc.applicable !== false) {
          codes.add(dc.code.toUpperCase());
        }
      });
      
      // SECONDARY: cart-level discount applications (order discounts)
      cart?.cart_level_discount_applications?.forEach(app => {
        const title = app.title || app.discount_application?.title;
        if (title && (app.type === 'discount_code' || app.discount_application?.type === 'discount_code')) {
          codes.add(title.toUpperCase());
        }
      });
      
      // SECONDARY: line-level discount allocations on items (product discounts)
      cart?.items?.forEach(item => {
        item?.line_level_discount_allocations?.forEach(allocation => {
          const title = allocation.discount_application?.title;
          if (title && allocation.discount_application?.type === 'discount_code') {
            codes.add(title.toUpperCase());
          }
        });
      });
      
      return codes;
    };
    
    // Check if discount is ALREADY applied in the cart
    const alreadyAppliedCodes = getAppliedDiscountCodes(freshCart);
    
    // Check for automatic discounts that might prevent combination
    const automaticDiscountsOnCart = freshCart?.cart_level_discount_applications?.filter(
      app => app.type === 'automatic' || app.discount_application?.type === 'automatic'
    ) || [];
    
    // Check if this code is ALREADY applied
    if (alreadyAppliedCodes.has(sanitizedCode.toUpperCase())) {
      showMessage(`Discount code "${sanitizedCode.toUpperCase()}" is already applied.`, false);
      stopLoader();
      return;
    }
    
    // Get existing codes to preserve them
    const currentCodes = [...alreadyAppliedCodes];
    
    // Apply the new discount code using Shopify's /discount/CODE endpoint
    await orgFetch(`${base}discount/${encodeURIComponent(sanitizedCode)}`, {
      method: 'GET',
      redirect: 'manual',
      credentials: 'same-origin'
    });
    
    // Fetch updated cart to verify if discount was applied
    const updatedCart = await orgFetch(`${base}cart.js`).then(r => r.json());
    user_cart = updatedCart;
    
    // Get newly applied codes after applying
    const newlyAppliedCodes = getAppliedDiscountCodes(updatedCart);
    const wasApplied = newlyAppliedCodes.has(sanitizedCode.toUpperCase());
    
    // Also check if it's in the discount_codes array with applicable status
    const discountCodeEntry = updatedCart?.discount_codes?.find(
      dc => dc.code?.toUpperCase() === sanitizedCode.toUpperCase()
    );
    const isApplicable = discountCodeEntry?.applicable !== false;
    
    if (wasApplied && isApplicable) {
      // Success: discount was actually applied
      currentDiscountCodes = [...newlyAppliedCodes];
      showConfetti = true; // Trigger confetti animation on cart reload
      
      // Clear input
      const inputs = document.querySelectorAll('.prv-coupon-input');
      inputs.forEach(input => input.value = '');
      
      // Update in-memory; syncDiscountAttributes will persist on next cycle
      if (user_cart) {
        user_cart.attributes = user_cart.attributes || {};
        user_cart.attributes.appliedDiscountCodes = [...newlyAppliedCodes].join(',');
      }
      currentDiscountCodes = [...newlyAppliedCodes];

      pendingMessage = { text: `Discount code "${sanitizedCode.toUpperCase()}" applied successfully!`, isError: false };
      reload_cartx();
    } else if (discountCodeEntry && !isApplicable) {
      // Code exists but not applicable (can't combine, wrong products, etc.)
      // Check for automatic discounts that might be blocking
      const automaticDiscounts = updatedCart?.cart_level_discount_applications?.filter(
        app => app.type === 'automatic' || app.discount_application?.type === 'automatic'
      ) || [];
      const manualDiscounts = updatedCart?.discount_codes?.filter(dc => dc.applicable && dc.code?.toUpperCase() !== sanitizedCode.toUpperCase()) || [];
      
      let errorMessage = `Discount code "${sanitizedCode.toUpperCase()}" cannot be combined with `;
      if (automaticDiscounts.length > 0) {
        const autoNames = automaticDiscounts.map(d => d.title || 'automatic discount').join(', ');
        errorMessage += `the automatic discount "${autoNames}" currently applied to your cart. It may also be invalid.`;
      } else if (manualDiscounts.length > 0) {
        const manualNames = manualDiscounts.map(d => d.code).join(', ');
        errorMessage += `existing code "${manualNames}". It may also be invalid.`;
      } else if (alreadyAppliedCodes.size > 0) {
        errorMessage += `"${[...alreadyAppliedCodes].join(', ')}". It may also be invalid.`;
      } else {
        errorMessage = `Discount code "${sanitizedCode.toUpperCase()}" cannot be applied. It may be expired or not valid for the products in your cart.`;
      }
      
      // Only clear the Shopify session if the failure was NOT due to an automatic discount conflict.
      // Use freshCart (pre-apply) for the check — updatedCart may have empty applications during a conflict.
      // Also check knownAutomaticCodes in case allocations are temporarily absent.
      const cartHadAutoDiscount = automaticDiscountsOnCart.length > 0 || knownAutomaticCodes.size > 0;
      if (!cartHadAutoDiscount) {
        // Clear discount + overwrite session in minimal calls
        await orgFetch(`${base}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: "" })
        });
        await orgFetch(`${base}discount/CLEAR_INVALID_${Date.now()}`, {
          method: 'GET',
          redirect: 'manual',
          credentials: 'same-origin'
        });
        if (currentCodes.length > 0) {
          for (const code of currentCodes) {
            await orgFetch(`${base}discount/${encodeURIComponent(code)}`, {
              method: 'GET',
              redirect: 'manual',
              credentials: 'same-origin'
            });
          }
          user_cart = await orgFetch(`${base}cart.js`).then(r => r.json());
        }
      }

      pendingMessage = { text: errorMessage, isError: true };
      reload_cartx();
    } else {
      // Code doesn't exist in response - invalid or expired
      // Re-apply previously valid codes to restore the session
      if (currentCodes.length > 0) {
        for (const code of currentCodes) {
          await orgFetch(`${base}discount/${encodeURIComponent(code)}`, {
            method: 'GET',
            redirect: 'manual',
            credentials: 'same-origin'
          });
        }
        user_cart = await orgFetch(`${base}cart.js`).then(r => r.json());
      }
      pendingMessage = { text: `Discount code "${sanitizedCode.toUpperCase()}" is invalid or has expired.`, isError: true };
      reload_cartx();
    }
    
  } catch (error) {
    console.error('Error applying discount:', error);
    showMessage('Error applying discount. Please try again.', true);
    stopLoader();
  }
}

let isRemovingDiscount = false;

async function removeDiscount(_cartId, discountCode) {
  if (isRemovingDiscount) return;
  if (!discountCode) {
    showMessage("No discount code specified.", true);
    return;
  }

  // Guard against all call sites — not just the chip handler
  if (knownAutomaticCodes.has(discountCode.toUpperCase())) {
    showMessage("Auto-applied coupon can't be removed", true);
    return;
  }

  isRemovingDiscount = true;
  startLoader();
  showMessage("Removing discount...", false);

  try {
    const base = getCartBase();
    const codeUpper = discountCode.toUpperCase();
    
    // Get current cart state
    const currentCart = await orgFetch(`${base}cart.js`).then(r => r.json());
    
    // Get currently applied discount codes
    const currentCodes = currentCart.discount_codes?.filter(dc => dc.applicable) || [];
    const currentCodeNames = currentCodes.map(dc => dc.code.toUpperCase());
    
    // Filter out the code we want to remove
    const remainingCodes = currentCodeNames.filter(code => code !== codeUpper);
    
    // Step 1: Overwrite Shopify checkout session with a dummy code
    await orgFetch(`${base}discount/CLEAR_INVALID_${Date.now()}`, {
      method: 'GET',
      redirect: 'manual',
      credentials: 'same-origin'
    });

    // Step 2: Clear discount + update attributes in one call
    await orgFetch(`${base}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: "", attributes: { appliedDiscountCodes: remainingCodes.join(',') } })
    });

    // Step 4: Re-apply any remaining manual codes
    if (remainingCodes.length > 0) {
      await orgFetch(`${base}discount/${encodeURIComponent(remainingCodes[0])}`, {
        method: 'GET',
        redirect: 'manual',
        credentials: 'same-origin'
      });
    }

    // Fetch updated cart
    const updatedCart = await orgFetch(`${base}cart.js`).then(r => r.json());
    user_cart = updatedCart;

    const applicableCodes = updatedCart.discount_codes?.filter(dc => dc.applicable) || [];
    currentDiscountCodes = applicableCodes.map(dc => dc.code.toUpperCase());
    
    showMessage(`Discount code "${codeUpper}" removed.`, false);
    reload_cartx(); // checkDiscountCode is called inside reload_cartx.finally()
    
  } catch (error) {
    console.error('Error removing discount:', error);
    showMessage('Error removing discount. Please try again.', true);
    stopLoader();
  } finally {
    isRemovingDiscount = false;
  }
}

function checkDiscountCode(cart) {
  // If cart is empty, clear all discount code chips and stored attributes AND session
  if (!cart || cart.item_count === 0) {
    currentDiscountCodes = [];
    renderAppliedDiscountCodes([]);
    
    const base = getCartBase();
    
    // Clear discount + attributes in one call, then overwrite session
    orgFetch(`${base}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: "", attributes: { appliedDiscountCodes: '' } })
    }).then(() => {
      return orgFetch(`${base}discount/CLEAR_INVALID_${Date.now()}`, {
        method: 'GET',
        redirect: 'manual',
        credentials: 'same-origin'
      });
    }).catch(() => {});

    return;
  }

  // Build a set of codes confirmed automatic from the current cart's allocation data.
  // Also update knownAutomaticCodes (module-level) so we remember across renders —
  // Shopify can temporarily drop allocations during discount conflicts, but the code
  // is still automatic and shouldn't be reclassified.
  const automaticCodes = new Set();
  cart?.items?.forEach((item) => {
    item.line_level_discount_allocations?.forEach((alloc) => {
      if (alloc.discount_application?.type === 'automatic') {
        const title = (alloc.discount_application?.title || '').toUpperCase();
        automaticCodes.add(title);
        _persistAutoCode(title);
      }
    });
  });
  cart?.cart_level_discount_applications?.forEach((item) => {
    const type = item.discount_application?.type || item.type;
    if (type === 'automatic') {
      const title = (item.discount_application?.title || item.title || '').toUpperCase();
      automaticCodes.add(title);
      _persistAutoCode(title);
    }
  });

  // Helper: a code is automatic if current cart says so, OR we've seen it as automatic before.
  const isKnownAutomatic = (code) => automaticCodes.has(code) || knownAutomaticCodes.has(code);

  // Collect all discounts with their type (for different UI treatment)
  const discountCodes = []; // { code: string, type: 'discount_code' | 'automatic', removable: boolean }
  const seenCodes = new Set();

  // Line-level allocations
  cart?.items?.forEach((item) => {
    item.line_level_discount_allocations?.forEach((alloc) => {
      const title = (alloc.discount_application?.title || '').toUpperCase();
      if (title && !seenCodes.has(title)) {
        seenCodes.add(title);
        const isAutomatic = isKnownAutomatic(title);
        discountCodes.push({ code: title, type: isAutomatic ? 'automatic' : 'discount_code', removable: !isAutomatic });
      }
    });
  });

  // Cart-level applications
  cart?.cart_level_discount_applications?.forEach((item) => {
    const title = (item.discount_application?.title || item.title || '').toUpperCase();
    if (title && !seenCodes.has(title)) {
      seenCodes.add(title);
      const isAutomatic = isKnownAutomatic(title);
      discountCodes.push({ code: title, type: isAutomatic ? 'automatic' : 'discount_code', removable: !isAutomatic });
    }
  });

  currentDiscountCodes = discountCodes.map(d => d.code);

  // Render applied codes as chips below input
  renderAppliedDiscountCodes(discountCodes);
}

// Function to render applied discount codes as chips below the input field
// codes can be array of strings OR array of { code, type, removable } objects
function renderAppliedDiscountCodes(codes) {
  const containers = document.querySelectorAll('.cartx-applied-codes-container');
  
  containers.forEach(container => {
    // Clear existing chips
    container.innerHTML = '';
    
    if (!codes || codes.length === 0) {
      return;
    }
    
    codes.forEach(codeItem => {
      // Support both string array and object array
      const code = typeof codeItem === 'string' ? codeItem : codeItem.code;
      const isAutomatic = typeof codeItem === 'object' && codeItem.type === 'automatic';
      
      const chip = document.createElement('span');
      chip.className = 'cartx-discount-chip' + (isAutomatic ? ' cartx-discount-chip-auto' : '');
      
      // Always show remove button for all discount types
      chip.innerHTML = `
        <span class="cartx-discount-chip-text">${code}</span>
        <button class="cartx-discount-chip-remove" data-code="${code}" data-type="${isAutomatic ? 'automatic' : 'discount_code'}" aria-label="Remove discount code ${code}">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
          </svg>
        </button>
      `;
      
      // Add click event for remove button
      const removeBtn = chip.querySelector('.cartx-discount-chip-remove');
      removeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const codeToRemove = removeBtn.getAttribute('data-code');
        const discountType = removeBtn.getAttribute('data-type');
        
        // Check if it's an auto-applied discount
        if (discountType === 'automatic') {
          showMessage("Auto-applied coupon can't be removed", true);
          return;
        }
        
        removeDiscount(user_cart?.token, codeToRemove);
      });
      
      container.appendChild(chip);
    });
  });
}

function showMessage(message, isError = false) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 5000);
}

function showExceedingMessage(message) {
  const messageElement = document.querySelector(".cartx-apply-code__message"); // replace with actual selector
  if (!messageElement) return;

  const messageElementWrapper = document.querySelector(
    ".cartx-apply-code-wrapper"
  );
  if (!messageElementWrapper) return;

  messageElement.textContent = message;
  messageElementWrapper.classList.add("show-message");
  // messageElement.style.color = isError ? "red" : "green";

  setTimeout(() => {
    messageElementWrapper.classList.remove("show-message");
    messageElement.textContent = "";
    // messageElement.style.color = "";
  }, 5000);
}


function updateAiUpsell(cartItems) {
  document.querySelectorAll(".cartx-ai-upsell").forEach(wrap => {
    const container = wrap.querySelector(".cartx-upsell-product-list");
    if (!cartItems || cartItems.length === 0 || !container) {
      wrap.style.display = "none";
      return;
    }

    // Price-based upsell: fetch from collection API, filter, randomize
    if (wrap.hasAttribute("data-price-based-upsell")) {
      const handle = wrap.dataset.collectionHandle;
      if (!handle) { wrap.style.display = "none"; return; }
      const priceCap = parseInt(wrap.dataset.priceCap, 10) || 0;
      const productsLimit = parseInt(wrap.dataset.productsLimit, 10) || 5;
      const productsCount = parseInt(wrap.dataset.productsCount, 10) || 0;
      const cartIds = (wrap.dataset.cartVariantIds || "")
        .split(",")
        .filter(Boolean);

      wrap.style.display = "";
      fetchAndRenderPriceBasedUpsell(container, handle, priceCap, cartIds, productsCount, productsLimit);
      return;
    }

    // Original Liquid-rendered upsell: just toggle visibility
    const allItems = container.querySelectorAll('.cartx-upsell-product-item');
    const hiddenItems = container.querySelectorAll('.cartx-upsell-product-item[style*="display: none"]');
    const hasVisible = allItems.length > 0 && allItems.length > hiddenItems.length;
    wrap.style.display = hasVisible ? "" : "none";
  });

  loadedEvents();
}

/**
 * Fetches ALL products from a collection (paginated, up to 250/page),
 * filters by price cap and cart exclusion, shuffles, and renders 5 random items.
 * Re-queries DOM after fetch to avoid stale references from reload_cartx() race.
 */
let _upsellFetchId = 0;
async function fetchAndRenderPriceBasedUpsell(container, handle, priceCap, cartVariantIds, productsCount, productsLimit) {
  const fetchId = ++_upsellFetchId;
  const perPage = 250;

  // Pick a random page so products shuffle on every cart update (single API call)
  const totalPages = Math.max(1, Math.ceil((productsCount || 50) / perPage));
  const randomPage = Math.floor(Math.random() * totalPages) + 1;

  try {
    const res = await fetch(
      `/collections/${encodeURIComponent(handle)}/products.json?limit=${perPage}&page=${randomPage}`
    );
    if (!res.ok) throw new Error('Fetch failed: ' + res.status);
    const data = await res.json();
    let allProducts = data.products || [];

    // If random page was empty (overshot), fall back to page 1
    if (allProducts.length === 0 && randomPage > 1) {
      const fallback = await fetch(
        `/collections/${encodeURIComponent(handle)}/products.json?limit=${perPage}&page=1`
      );
      if (fallback.ok) {
        const fbData = await fallback.json();
        allProducts = fbData.products || [];
      }
    }

    // Abort if a newer fetch was started (reload_cartx race)
    if (fetchId !== _upsellFetchId) {
      return;
    }


    // Filter: variant available, not in cart, under price cap (if set)
    // priceCap is in dollars (e.g. 20 = $20)
    // Shopify products.json may return prices as dollars ("19.99") or cents ("1999")
    const eligible = allProducts.filter(p => {
      const variant = p.variants && p.variants[0];
      if (!variant || !variant.available) return false;
      if (cartVariantIds.includes(String(variant.id))) return false;
      if (priceCap > 0) {
        const priceStr = String(variant.price);
        // Detect format: decimal point = dollars, no decimal = cents
        const priceDollars = priceStr.includes('.')
          ? parseFloat(priceStr)
          : parseFloat(priceStr) / 100;
        if (priceDollars >= priceCap) return false;
      }
      return true;
    });

    // Fisher-Yates shuffle
    for (let i = eligible.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [eligible[i], eligible[j]] = [eligible[j], eligible[i]];
    }

    // Take up to the configured limit (default 5)
    const picks = eligible.slice(0, productsLimit || 5);

    // Re-query DOM for the CURRENT container (may have been replaced by reload_cartx)
    const freshWrap = document.querySelector('.cartx-ai-upsell[data-price-based-upsell]');
    const freshContainer = freshWrap ? freshWrap.querySelector('.cartx-upsell-product-list') : null;
    if (!freshContainer) {
      return;
    }

    freshContainer.innerHTML = "";
    if (picks.length === 0) {
      freshWrap.style.display = "none";
      return;
    }

    freshWrap.style.display = "";
    picks.forEach(product => {
      const variant = product.variants[0];
      // Shopify products.json may return dollars ("19.99") or cents ("1999")
      const priceStr = String(variant.price);
      const priceDollars = priceStr.includes('.')
        ? parseFloat(priceStr)
        : parseFloat(priceStr) / 100;

      const compareStr = variant.compare_at_price ? String(variant.compare_at_price) : "";
      const compareDollars = compareStr
        ? (compareStr.includes('.') ? parseFloat(compareStr) : parseFloat(compareStr) / 100)
        : 0;

      const imgSrc = product.images && product.images[0]
        ? product.images[0].src.replace(/\.([^.]+)$/, "_174x.$1")
        : (product.image ? product.image.src.replace(/\.([^.]+)$/, "_174x.$1") : "");

      let priceHtml = `<span class="current-price">$${priceDollars.toFixed(2)}</span>`;
      if (compareDollars > 0 && compareDollars > priceDollars) {
        priceHtml += ` <span class="original-price">$${compareDollars.toFixed(2)}</span>`;
      }

      const itemHtml = `
        <div class="cartx-upsell-product-item" data_prod_id="${variant.id}" data-variant-id="${variant.id}">
          <div class="cartx-upsell-item-media">
            <img class="cartx-upsell-item-img" width="74" height="74" src="${imgSrc}" alt="${product.title}">
          </div>
          <div class="cartx-upsell-item-info">
            <div class="cartx-upsell-item-header">
              <div class="cartx-item-vendor"><span>${product.vendor || ""}</span></div>
              <div class="cartx-drawer-product-title-wrap" style="width:200px">
                <a href="/products/${product.handle}" class="cartx-drawer-product-title">${product.title}</a>
              </div>
            </div>
            <div class="cartx-upsell-item-price-wrap">
              <div class="cartx-upsell-item-price">${priceHtml}</div>
            </div>
          </div>
          <div class="cartx-product-button-wrap"
            data-product-type="${product.product_type || ""}"
            data-quantity="1"
            data-price="${Math.round(priceDollars * 100)}"
            data-variant-id="${variant.id}">
            <div class="cartx-add-to-cart button">
              <span>Add to bag</span>
              <div class="cartx-atc-loading" style="display:none;">
                <svg width="16" height="16" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <path fill="white" d="M9.9 0.2l-0.2 1c3 0.8 5.3 3.5 5.3 6.8 0 3.9-3.1 7-7 7s-7-3.1-7-7c0-3.3 2.3-6 5.3-6.8l-0.2-1c-3.5 0.9-6.1 4.1-6.1 7.8 0 4.4 3.6 8 8 8s8-3.6 8-8c0-3.7-2.6-6.9-6.1-7.8z"></path>
                </svg>
              </div>
            </div>
          </div>
        </div>`;
      freshContainer.insertAdjacentHTML("beforeend", itemHtml);
    });
    // Re-bind add-to-cart click events on the new items
    loadedEvents();
  } catch (err) {
    console.error("Fetch error:", err);
    const wrap = document.querySelector('.cartx-ai-upsell[data-price-based-upsell]');
    if (wrap) wrap.style.display = "none";
  }
}

// function triggerUpsellEvent() {
//   document.querySelectorAll(".cartx-upsell-add-to-cart").forEach((button) => {
//     button.addEventListener("click", (event) => {
//       event.preventDefault();
//       const variantId = button.getAttribute("data-variant-id");
//       if (!variantId) return;

//       const variantObject = {
//         [variantId]: {
//           quantity: parseInt(button.getAttribute("data-quantity")) || 0,
//           price: parseInt(button.getAttribute("data-price")) || 0,
//           type: button.getAttribute("data-product-type") || "",
//         },
//       };

//       cartx(variantObject, "ADD");
//     });
//   });
// }

function cartConfetti() {
  // Note: Success message is now shown by applyDiscount() function
  // This function only handles the confetti animation

  // Check if lottie is available
  if (typeof lottie !== 'undefined') {
    var animation = lottie.loadAnimation({
      container: document.getElementById('cartx-confetti'),
      renderer: 'svg',
      loop: false,
      autoplay: false,
      path: 'https://cdn.shopify.com/s/files/1/0633/2183/3679/files/Main_Scene.json?v=1746784652'
    });

    animation.goToAndStop(0, true);
    animation.play();

    animation.addEventListener('complete', function () {
      animation.destroy();
      document.getElementById('cartx-confetti').innerHTML = '';
    });
  } else {
    // Fallback: Simple text-based celebration or just the success message
    console.log('Lottie library not available, skipping confetti animation');
  }
}

// ===== IDLE CART EXPIRY (7 DAYS) =====
// Clears cart after 7 days of no cart mutations (add/update/change).
// Uses setTimeout so it works even if the tab stays open without a page reload.
// Timer resets on every cart mutation via window._resetCartIdleTimer().
(function() {
  var IDLE_MAX_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
  var COOKIE_NAME = 'cartx_last_active';
  var timerId = null;

  function clearIdleCart() {
    orgFetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
      .then(function() {
        document.cookie = COOKIE_NAME + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        if (typeof updateBubble === 'function') updateBubble(0);
        reload_cartx();
      })
      .catch(function(err) { console.error('[CartIdleExpiry] Error clearing cart:', err); });
  }

  function scheduleTimer() {
    if (timerId) clearTimeout(timerId);

    var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    var lastActive = match ? Number(match[1]) : null;

    if (!lastActive) return; // No cart activity yet — nothing to expire

    var elapsed = Date.now() - lastActive;
    if (elapsed >= IDLE_MAX_MS) {
      clearIdleCart();
    } else {
      timerId = setTimeout(clearIdleCart, IDLE_MAX_MS - elapsed);
    }
  }

  // Expose so the fetch interceptor can reset the timer on cart mutations
  window._resetCartIdleTimer = scheduleTimer;

  // Script is loaded with defer, so DOMContentLoaded has already fired — run immediately
  scheduleTimer();
})();

// Expose functions globally
window.openDrawer = openDrawer;
window.closeDrawer = closeDrawer;